/** KR = operator UI (legacy mixed). EN = full English. FR = French. */
export const dashboardMessages = {
  kr: {
    'common.refresh': '새로고침',
    'common.loading': '로딩 중…',
    'common.close': '닫기',
    'common.tradeHistory': 'Trade history',
    'common.table.symbol': 'Symbol',
    'common.table.status': 'Status',
    'common.table.pnl': 'PnL',
    'common.table.detail': 'Detail',
    'common.table.entry': 'Entry',
    'common.table.exit': 'Exit',
    'common.table.reason': 'Reason',
    'common.table.side': 'Side',
    'common.table.qty': 'Qty',
    'common.table.pair': 'Pair',
    'common.table.hold': 'Hold',
    'dashboard.mobileTabs.ariaLabel': '거래소',
    'alertType.segment_rise': '구간 상승',
    'alertType.segment_fall': '구간 하락',
    'alertType.short_term_rise': '단기 급등',
    'alertType.short_term_drop': '단기 급락',
    'alertType.buy_pressure': '매수세',
    'alertType.listing': '상장',
    'alertType.new_low': '신저가',
    'alertType.new_high': '신고가',
    'alertType.unknown': '기타',
    'binance.subtitle.line1': 'Binance USDⓈ-M에서 무기한거래',
    'binance.stat.filter': '상세',
    'binance.stat.filter.viewCount': '{n}개 보기',
    'binance.stat.filter.title': '적용 중인 필터 보기 (두 레인 모두)',
    'binance.stat.available': '남은 증거금',
    'binance.stat.available.title': '신규 진입에 쓸 수 있는 가용 증거금. 포지션이 이미 잡은 개시증거금은 빠져 있다.',
    'binance.stat.weekPnl': '이번 주 PnL',
    'binance.stat.weekPnl.title': '계좌 전체(두 레인 공용) · 클릭하면 주간 실현손익 보기 (두 레인 합산 — 레인별 누적은 각 레인 손익 칸)',
    'binance.stat.weekPnl.tradeCount': '{n}건',
    'binance.stat.drawdown': 'Drawdown',
    'binance.stat.drawdown.title': 'How far the balance has slipped since the mountain opened. (now/start − 1)×100.',
    'binance.stat.transfer': 'Transfer',
    'binance.stat.transfer.in': 'Deposit   ',
    'binance.stat.transfer.out': 'Withdraw',
    'binance.stat.transfer.title': '선물 지갑 TRANSFER 합계(USDT·USDC). 거래 손익·스왑 아님',
    'binance.stat.phone': 'Notifier',
    'binance.stat.phone.ok': '정상',
    'binance.stat.phone.silent': '박동 끊김',
    'binance.stat.phone.listenerOff': '알림접근 꺼짐',
    'binance.stat.phone.batteryOn': '배터리최적화 켜짐',
    'binance.stat.phone.title': '알림 수집 폰(notifier-android). 3분마다 박동을 보낸다 — 끊기면 알림이 아예 안 들어온다',
    'binance.stat.trader': 'Trader',
    'binance.stat.trader.alive': '살아 있음 · {n}초',
    'binance.stat.trader.aliveNoAge': '살아 있음',
    'binance.stat.trader.age': '{n}초',
    'binance.stat.trader.dead': '죽어 있음 · {n}초',
    'binance.stat.trader.deadNoAge': '죽어 있음',
    'binance.stat.trader.stale': '멈춤 · {n}초',
    'binance.stat.trader.down': '응답 없음',
    'binance.stat.trader.title': '프로세스가 running 인지. 뒤의 초는 화면 데이터가 얼마나 묵었는지',
    'binance.stat.host.collect': '수집',
    'binance.stat.host.disk': '디스크',
    'binance.stat.host.ok': '정상',
    'binance.stat.host.down': '끊김',
    'binance.stat.host.unknown': '확인 불가',
    'binance.stat.host.free': '여유 {n}%',
    'binance.stat.host.mark': '마크',
    'binance.stat.host.agg': '체결',
    'binance.stat.host.spot': '현물',
    'binance.stat.host.oi': '미결제',
    'binance.stat.host.liq': '청산',
    'binance.stat.host.title': 'analyser 상시 수집. 마크·체결·현물·미결제·청산의 마지막 행 나이. 3분(청산 10분)을 넘기면 끊긴 것이다',
    'binance.stat.host.diskTitle': 'analyser 루트 디스크 남은 용량. 25% 미만은 노랑, 15% 미만은 빨강',
    'binance.stat.equityCurve': '자본 추이',
    'binance.stat.equityCurve.title': '전체기간 자본 추이 (거래 단위, 두 레인 합산)',
    'binance.stat.upbit': '업비트',
    'binance.stat.upbit.title': '보유/슬롯 · 승/정산',
    'binance.stat.upbitPnl': '업비트 손익',
    'binance.stat.realizedPnl': '실현손익',
    'binance.stat.realizedPnl.title': '레인별 실현손익 (USDT). 업숏 · 빗숏 · 청캐 · 편승 · 쌍숏',
    'binance.lane.upbit': '업숏',
    'binance.lane.bithumb': '빗숏',
    'binance.lane.total': '합',
    'binance.lane.liq': '청캐',
    'binance.lane.candLong': '빗롱',
    'binance.lane.pumpRide': '편승',
    'binance.lane.gyeopLong': '겹롱',
    'binance.lane.stairLong': '급롱',
    'binance.lane.dualShort': '쌍숏',
    'binance.lane.inactive': 'inactive',
    'binance.lane.active': 'active',
    'binance.stat.slip': '슬리피지 (실측)',
    'binance.stat.slip.title': '레인별 진입 슬리피지 중앙값(bp). 실체결가 - 주문직전 참조가. 음수 = 불리. 실체결가를 받은 건만 센다(참조가로 대체된 건은 정의상 0 이라 제외). 백테는 왕복 수수료 10bp 만 넣고 슬리피지는 0 으로 둔다 -- 이 값이 그 가정과의 차이다',
    'binance.stat.slip.roundtrip': '왕복추정',
    'binance.stat.timing': '레인 타이밍 (고점 · 진입 · 보유)',
    'binance.stat.timing.title': '알림 뒤 바이낸스 고점까지 걸린 분(t_peak). 위 3줄은 주별 중앙(추세용), 아래 고점은 최근 N건 롤링 중앙과 95% 신뢰구간이다(N 은 옆에 n 으로 표시, yaml lane_timing_roll_n) -- 주 경계로 자르면 주 초에 표본이 한 자리로 떨어져 한두 건에 10분씩 흔들린다. 2026-08-10 에 t_peak 이 +4분에서 +32분으로 밀린 것이 코어 레인 붕괴의 정체였다(Mann-Whitney z -4.51). 펌프 진폭과 알림이 펌프의 몇 %지점에 오는지는 무변화 -- 같은 크기의 펌프가 느려진 것이다. **판정은 진입지연이 t_peak 과 같은지가 아니다**: 중앙이 T 면 절반은 그 뒤에 고점을 찍으므로 T 에 들어가면 절반이 아직 오르는 중이다(실측: t_peak 32일 때 지연 20분 -0.352% / 60분 +1.288%). 위험한 상태는 지연이 t_peak 보다 **작을** 때다. 손익보다 먼저 움직인다',
    'binance.stat.timing.implied': '함의',
    'binance.stat.timing.peak': '고점',
    'binance.stat.timing.deployed': '진입',
    'binance.stat.timing.hold': '보유',
    'binance.stat.timing.match': '✓ 고점 뒤',
    'binance.stat.timing.mismatch': '불일치',
    'binance.stat.timing.early': '⚠ 고점 전',
    'binance.stat.timing.late': '⚠ 너무 늦음',
    'binance.stat.lanes': '레인 · 보유/k · 승/정산',
    'binance.stat.lanes.title': '레인별 보유/슬롯 · 승/정산. 청산 레인은 발동 대비 진입도 함께 (격차 = 슬롯·자본이 막은 양)',
    'binance.stat.lanesSize': '레인 · lev/노셔널',
    'binance.stat.lanesSize.title': '레인별 유효 레버리지와 건당 노셔널(USDT)',
    'binance.stat.lanes.col.lane': '레인',
    'binance.stat.lanes.col.status': '상태',
    'binance.stat.lanes.col.hold': '보유/k',
    'binance.stat.lanes.col.legs': '조각',
    'binance.stat.lanes.col.wins': '승/정산',
    'binance.stat.lanes.col.pnl.hint': '클릭하면 합계',
    'binance.stat.lanes.col.lev': 'lev',
    'binance.stat.lanes.col.notional': '노셔널',
    'binance.stat.lanes.col.timing': '보유',
    'binance.stat.lanes.col.stop': '스탑',
    'binance.stat.lanes.col.strategy': '전략',
    'binance.stat.lanes.col.strategy.hint': '그 레인이 지금 쓰는 서브전략. 순서는 보유·스탑 칸과 같다.',
    'binance.stat.lanes.col.stop.hint': '가격 스탑 %. 업숏은 저녁/산. 산은 +15%·OI−2% 시장가도 있다 (title).',
    'binance.stat.lanes.col.liveStats.hint': '현재 설정(config_id) 정산 · 없으면 최신 설정 폴백 — live_ledger.',
    'binance.stat.lanes.col.liveStats.title': '현재 설정 · n={n} · avg {avg} · 승률 {win} · {pnl} USDT · id {id}',
    'binance.stat.lanes.col.liveStats.empty': '이 설정으로 정산된 건 없음 (배포 직후·id 미스탬프 옛 건은 제외)',
    'binance.stat.liq.fired': '발동 {n} → 진입 {entered}',
    'binance.regime.col.week': '주',
    'binance.stat.upbitPnl.title': '업비트 레인 실현손익 (누적)',
    'binance.stat.upbitLev': '업비트 lev/노션',
    'binance.stat.upbitLev.title': '실제 체결 레버리지 / 요청값 · 건당 명목가 (업비트 리스크 사이징)',
    'binance.stat.bithumb': '빗썸',
    'binance.stat.bithumb.title': '보유/슬롯 · 승/정산',
    'binance.stat.bithumb.off': '꺼짐',
    'binance.stat.bithumbPnl': '빗썸 손익',
    'binance.stat.bithumbPnl.title': '빗썸 슬리브 실현손익 (누적)',
    'binance.stat.bithumbLev': '빗썸 lev/노션',
    'binance.stat.bithumbLev.title': '실제 체결 레버리지 · 기본 명목가와 분봉 거래대금 캡 (업비트와 사이징 규칙이 다르다)',
    'binance.tradeHistory.enteredOnly': '진입(예정)',
    'binance.tradeHistory.enteredOnly.title.hidden': 'WATCH(청캐 감시 포함) + 진입한 행(OPEN/EXIT)만 표시 · 끝난 감시/스킵 {n}건 숨김',
    'binance.tradeHistory.enteredOnly.title.all': '끝난 감시·스킵 행도 함께 보기',
    'binance.tradeHistory.neededOnly': '필요한',
    'binance.tradeHistory.neededOnly.title.hidden': '업비트 + 빗썸 신고가만 표시 · 수집/미해석 {n}건 숨김',
    'binance.tradeHistory.neededOnly.title.all': '수집 전용 알림도 함께 보기',
    'binance.tradeHistory.title': 'Trade history',
    'binance.table.header.symbol': 'Symbol',
    'binance.table.header.status': 'Status',
    'binance.table.header.alert': 'Alert',
    'binance.table.header.sizing': 'Sizing',
    'binance.table.header.chart': 'Charts',
    'binance.table.header.pnl': 'PnL',
    'binance.manualClose.button': '청산',
    'binance.manualClose.confirm': '정말?',
    'binance.manualClose.working': '요청 중…',
    'binance.manualClose.queued': '큐 등록 · {eta}초 내 매도',
    'binance.manualClose.cancelled': '취소됨',
    'binance.manualClose.failed': '실패: {error}',
    'binance.manualClose.title': '{perp} 를 지금 판다. 패스키(Face ID/Touch ID) 확인 뒤 봇이 다음 사이클에 매도한다.',
    'binance.manualEntry.button': '진입',
    'binance.manualEntry.confirm': '정말?',
    'binance.manualEntry.working': '요청 중…',
    'binance.manualEntry.queued': '큐 등록 · {eta}초 내 진입',
    'binance.manualEntry.entered': '성공함',
    'binance.manualEntry.failed': '실패: {error}',
    'binance.manualEntry.timeout': '결과 지연 — 표에서 확인',
    'binance.manualEntry.reason.lane_busy': '{holder} 레인이 이미 보유',
    'binance.manualEntry.reason.lane_busy.unknown': '다른 레인이 이미 보유',
    'binance.manualEntry.holder.liq': '청산',
    'binance.manualEntry.holder.upbit': '업숏',
    'binance.manualEntry.holder.bh': '빗썸',
    'binance.manualEntry.holder.cl': '빗롱',
    'binance.manualEntry.holder.long': '롱',
    'binance.manualEntry.holder.orphan': '거래소 고아',
    'binance.manualEntry.reason.margin': '증거금 부족',
    'binance.manualEntry.reason.liq_reserve': '청산 레인 증거금 예약',
    'binance.manualEntry.reason.liq_priority': '청캐 우선 · 업숏 양보',
    'binance.manualEntry.reason.already_open': '같은 심볼 업숏 보유중',
    'binance.manualEntry.reason.slot_full': '슬롯 가득',
    'binance.manualEntry.reason.late': '대기창 만료',
    'binance.manualEntry.reason.halted': '트레이더 정지',
    'binance.manualEntry.reason.min_notional': '최소노션 미달',
    'binance.manualEntry.reason.capacity': '용량 초과',
    'binance.manualEntry.reason.entry_fail': '주문 실패',
    'binance.manualEntry.reason.no_pullback': '되돌림 미발생',
    'binance.manualEntry.reason.runup_low': 'runup 부족',
    'binance.manualEntry.reason.rv_low': '변동성 부족',
    'binance.manualEntry.reason.no_drop': '꺾임 부족',
    'binance.manualEntry.reason.kr_segment_high': 'KR 구간고점 게이트',
    'binance.manualEntry.reason.hot_ban': 'abort/no_pullback 뒤 재숏 금지',
    'binance.manualEntry.reason.scout_run_hi': '당일첫 · watch 과대 (scout)',
    'binance.manualEntry.title': '{perp} 를 지금 진입한다. 패스키 확인 뒤 봇이 되돌림 대기 없이 주문한다.',
    'binance.table.header.detail': 'Detail',
    'binance.table.header.exchange.title': '거래소',
    'binance.table.header.lane.title': '레인',
    'binance.table.empty': '이벤트 없음',
    'binance.exchange.short.upbit': '업',
    'binance.exchange.short.bithumb': '빗',
    'binance.exchange.short.coinone': '코',
    'binance.exchange.full.upbit': '업비트',
    'binance.exchange.full.bithumb': '빗썸',
    'binance.exchange.full.coinone': '코인원',
    'binance.exchange.full.unknown': '미상',
    'binance.status.alert': 'ALERT',
    // 청산 캐스케이드 레인은 **알림이 없다** -- 바이낸스 청산 스트림이 곧 사건이라
    // 머리 줄에 'ALERT' 가 붙으면 오지도 않은 국내 알림을 말하게 된다
    // (2026-08-22 유저 지적: "16:55 ALERT 의 ZECUSDT 는 뭐라고 보여야 정상이야?").
    'binance.status.trigger': 'TRIGGER',
    'binance.status.pending': 'PENDING',
    'binance.status.exit': 'EXIT',
    'binance.status.open': 'OPEN',
    'binance.status.skip': 'SKIP',
    'binance.status.short': 'SHORT',
    'binance.status.reshort': 'RESHORT',
    'binance.status.long': 'LONG',
    'binance.status.fail': 'FAIL',
    'binance.status.collect': 'COLLECT',
    'binance.status.watch': 'WATCH',
    'binance.status.watchEnd': '감시종료',
    'binance.pnl.fee': '수수료 {amount}',
    'binance.pnl.funding': '펀딩 {amount}',
    'binance.skipPnl.stopped': '스톱',
    'binance.skipPnl.held': '{min}분 보유',
    'binance.skipPnl.pullbackHeld': '감시{watch}·보유{hold}분',
    'binance.skipPnl.noPullback': '되돌림 미발생',
    'binance.skipPnl.watchOnly': '감시{watch}분',
    'binance.skipPnl.coarse': '1분봉 추정',
    'binance.skipPnl.title': '진입하지 않은 거래의 가정 손익 ({lane} · {reason} · {bucket}). 실제 체결이 아니다. 차트는 알림가 대비 가격 경로다.',
    'binance.skipReport.title': '필터별 반사실 손익',
    'binance.skipReport.window': '전체 {days}일',
    'binance.skipReport.capacity': '용량',
    'binance.regime.title': '',
    'binance.regime.hint': 'live_ledger 실거래 — 주간 ISO주(KST)·레인별 건당%·승률%(n). 정산 즉시 DB·30s 폴링. 반사실 regime_weekly와 다름.',
    'binance.liqVitality.dead': 'DEAD',
    'binance.liqVitality.marginal': 'MARGINAL',
    'binance.liqVitality.alive': 'ALIVE',
    'binance.liqVitality.unknown': '–',
    'binance.liqVitality.live.off': 'OFF 유지',
    'binance.liqVitality.live.hold': 'HOLD',
    'binance.liqVitality.live.discuss': '켜기 논의',
    // 2026-08-31: 켜져 있는 레인에 "켜기 논의"가 뜨던 것을 갈랐다. 권고는
    // 숫자만으로 정해지지 않는다 -- 같은 ALIVE 라도 지금 켜져 있으면 유지다.
    'binance.liqVitality.live.keep': '유지',
    'binance.liqVitality.live.turn_off': '끄기 권고',
    'binance.liqVitality.roll': 'N{n}',
    'binance.liqVitality.hint': 'liq_trigger 롤링 채점(실효 되돌림·수수료·rescue). avg_net<0 또는 ratio<1.05→dead, avg>0·ratio≥1.5·n≥20→alive. yaml 자동 변경 없음.',
    'binance.abortReport.title': 'abort 반사실 — 안 끊었으면',
    'binance.stopReport.title': '스탑 반사실 — 스탑 없었으면',
    'binance.stopReport.empty': '스탑 0건. 스탑아웃이 나면 "스탑 없이 30분 들었으면?" 과 함께 여기 쌓인다(소급 없음).',
    'binance.stopReport.compare': '스탑 평균 {actual} vs 스탑 없이 30분 들었으면 {base}',
    'binance.longReport.title': '롱전환 반사실 — 탈출규칙 없었으면',
    'binance.longReport.empty': '롱전환 0건. abort 로 숏을 끊고 롱을 연 자리가 나오면 "신고가정체 탈출 없이 30분 들었으면?" 과 함께 여기 쌓인다(하드스탑 −2%는 유지).',
    'binance.longReport.compare': '롱 실현 평균 {actual} vs 탈출규칙 없이 홀드했으면 {base}',
    'binance.longSkipReport.title': '롱 미진입 반사실 — 열었으면',
    'binance.longSkipReport.empty': 'abort 로 숏은 끊었지만 롱을 안 연 자리 0건.',
    'binance.longSkipReport.compare': '{n}건 안 열었다. 열었으면 평균 {base} (합계 {sum}p) — 안 연 것이 손해라면 음수.',
    'binance.abortReport.empty': 'abort 발동 0건. 다리가 둘이고 OR 다 — 가격 급역행, 또는 OI 급증과 매수세 지속이 함께. 정확한 임계·창은 위 필터 목록의 abort 행에 있다(yaml 이 정본).',
    'binance.abortReport.saved': '{n}건 중 {saved}건에서 abort 가 이겼다.',
    'binance.abortReport.sum': '합계 {sum}p',
    'binance.abortReport.compare': 'abort 평균 {actual} vs 안 끊었으면 {base}',
    'binance.abortReport.stopRate': '안 끊었으면 6% 스탑에 닿았을 비율 {rate}',
    'binance.abortReport.pending': '채점 대기 {n}건 (30분 가상홀드 진행 중)',
    'binance.abortReport.note': '차이 > 0 이면 abort 가 손실을 막았고, < 0 이면 이익을 잘라먹었다. 가격원은 수집된 markPrice@1s.',
    'binance.abortReport.legTitle': '다리별',
    'binance.abortReport.legCol.leg': '다리',
    'binance.abortReport.legCellTitle': '{label} — {hint}',
    'binance.flipReport.title': 'flip 반사실 — flip 안 했으면',
    'binance.flipReport.col.type': 'flip 종류',
    'binance.flipReport.col.count': '발동',
    'binance.flipReport.col.betterRate': 'flip 우세',
    'binance.flipReport.col.avgDelta': '건당 Δ',
    'binance.flipReport.col.sumDelta': '순기여',
    'binance.flipReport.col.avgBase': 'flip 안 했으면',
    'binance.flipReport.col.avgTotal': '실제',
    'binance.flipReport.emptyOn': '발동 0건. 켜져 있는 flip: {on} — ⚠️ 다만 발동해도 기록되지 않는다(record_flip 미배선). 즉 "안 걸렸다" 가 아니라 "알 수 없다" 다.',
    'binance.flipReport.emptyOff': '발동 0건 — 켜져 있는 flip 이 없다.',
    'binance.flipReport.pending': '채점 대기 {n}건 (롱 레그 진행 중)',
    'binance.flipReport.note': '순기여 = 실제(숏 레그+롱 레그) − flip 안 했을 때(숏만). >0 이면 flip 이 벌어줬고, <0 이면 숏을 놔뒀어야 했다.',
    'binance.skipReport.lane.deployed': '배포 라인',
    'binance.skipReport.lane.research': '리서치',
    'binance.skipReport.col.filter': '필터',
    'binance.skipReport.col.count': '건수',
    'binance.skipReport.col.avg': '건당',
    'binance.skipReport.col.sum': '합계',
    'binance.skipReport.col.winRate': '승률',
    'binance.skipReport.col.stopRate': '스톱률',
    'binance.skipReport.verdict.costly': '거른 {n}건의 합이 {sum}% — 필터가 이만큼을 버렸다.',
    'binance.skipReport.verdict.worth': '거른 {n}건의 합이 {sum}% — 필터가 이만큼을 막았다.',
    'binance.skipReport.note': '진입 알림+1분 / 청산 +30분 / 6% 스톱, 라이브와 같은 규칙으로 채점한 가정값이다. 용량 표시 행(슬롯 부족 등)은 필터 품질이 아니라 합계에서 뺀다.',
    'binance.sizing.risk': '{pct}%',
    'binance.pnlModal.title': '실현손익',
    'binance.pnlModal.note': 'KST 기준. 백테스트가 아니라 실제 체결 손익이다.',
    'binance.pnlModal.empty': '청산된 거래가 없다.',
    'binance.pnlModal.col.period': '기간',
    'binance.pnlModal.col.count': '건수',
    'binance.pnlModal.col.winRate': '승률',
    'binance.pnlModal.col.stops': '스톱',
    'binance.pnlModal.col.perTrade': '건당',
    'binance.pnlModal.section.thisWeekDaily': '이번 주 일별 ({start} ~)',
    'binance.pnlModal.section.weekly': '주별',
    'binance.pnlModal.inProgress': '진행중',
    'binance.pnlModal.total': '전체 합계',
    'binance.filterModal.title': '지금 적용 중인 필터',
    'binance.filterModal.note': '실제 배포된 설정에서 읽어온 값이다. 문서가 아니라 지금 도는 봇 기준.',
    'binance.filterModal.lane.common': '공용 — 두 레인 모두',
    'binance.filterModal.lane.upbit': '업숏',
    'binance.filterModal.lane.bh': '빗숏',
    'binance.filterModal.lane.liq': '청캐',
    'binance.filterModal.count': '{n}개',
    'binance.filter.effect.skip': '알림 버림',
    'binance.filter.effect.entry': '진입 타이밍',
    'binance.filter.effect.size': '크기 조절',
    'binance.filter.effect.collect': '저장만',
    'binance.filter.effect.sleeve': '별도 레인',
    'binance.filter.effect.exit': '청산 규칙',
    'binance.filter.effect.pending': '보류 — 나중에 재검증',
    'binance.filter.effect.label_only': '시뮬레이션 — 주문 없음',
    'binance.skipReport.newlistingSim': '신규상장 면제 시뮬 (주문 없음)',
    'binance.newlistingReport.title': '신규상장 면제 반사실 — 면제했으면',
    'binance.newlistingReport.empty': '라벨 0건. 업비트 상장 {days}일 이내 심볼이 runup 하한에 걸리면 여기 쌓인다(소급 없음).',
    'binance.newlistingReport.sum': '{n}건 · 합계 {sum}p · 건당 {avg}',
    'binance.newlistingReport.rate': '승률 {win} · 스톱률 {stop}',
    'binance.newlistingReport.pending': '채점 대기 {n}건',
    'binance.newlistingReport.gate': '판정선 n≥{need} — 지금은 라벨만 남기고 주문은 내지 않는다.',
    'binance.segmentHighReport.title': 'segment_high 반사실 (≥40% 스킵) — 열었으면',
    'binance.segmentHighReport.empty': '채점된 segment_high 스킵 0건.',
    'binance.segmentHighReport.sum': '{n}건 · 합계 {sum}p · 건당 {avg}',
    'binance.segmentHighReport.rate': '승률 {win} · 스톱률 {stop}',
    'binance.segmentHighReport.abort': 'abort 재구성 {scored}건 중 발동 {fired}건',
    'binance.segmentHighReport.abortHint': '콜드티어(틱 존재, 2026-08-02~) 스탑만 재구성 가능. 0/N 이면 abort 가 이 스탑들을 하나도 못 막았다는 뜻 — segment_pct 급등은 완만상승이라 abort(초단위 급등 검출기)의 설계상 사각지대다(부록 A).',
    'binance.segmentHighReport.runupTitle': 'runup_60m_pct 밴드 (급등/완만 축)',
    'binance.segmentHighReport.segmentTitle': 'segment_pct 밴드 (40~50 / ≥50)',
    'binance.segmentHighReport.col.band': '밴드',
    'binance.segmentHighReport.gate.judged': '판정선 n≥{need} 충족 — 그래도 팻테일 단일종목 의존 여부는 별도 확인.',
    'binance.segmentHighReport.gate.notJudged': '판정 아님 — n={n}, 판정선 n≥{need}. 포워드 수집 중(문서 stream-upbit-segment-high-runup-short-2026-08-06 §결론).',
    'ibkr.swing.subtitle.line1': 'MES·MNQ·MGC·ZN 일봉 롱 · paper',
    'ibkr.swing.subtitle.line2': '일~목 18:15 ET 리밸런스',
    'ibkr.swing.subtitle.line3': 'Globex 일 18:00–금 17:00 ET · 휴장 17–18 ET',
    'ibkr.swing.legs.empty': '레그 없음',
    'ibkr.swing.section.legs': 'Legs',
    'ibkr.swing.trades.empty': '트레이드 없음',
    'ibkr.tfsa.subtitle.line1': 'TipRanks 애널리스트 확인 필터 (2/3)',
    'ibkr.tfsa.subtitle.line2': 'rank≤50 upgrade · stock SR≥70%',
    'ibkr.tfsa.subtitle.line3': 'upside≥15% · 주문 없음 (paper)',
    'ibkr.tfsa.table.empty': '로그 없음',
    'ibkr.tfsa.section.analystFilter': 'Analyst filter',
    'ibkr.tfsa.table.ticker': 'Ticker',
    'ibkr.tfsa.table.signal': 'Signal',
    'ibkr.tfsa.table.analyst': 'Analyst',
    'ibkr.tfsa.table.sr': 'SR',
    'ibkr.tfsa.table.upside': 'Upside',
    'ibkr.tfsa.table.conv': 'Conv',
    'kiwoom.pairs.subtitle.line1': 'KRX 은행·통신 z-score 페어',
    'kiwoom.pairs.subtitle.line2': 'EOD 16:05 KST · paper only',
    'kiwoom.pairs.subtitle.line3': '주문 없음 · 시뮬 체결만',
    'kiwoom.pairs.noSnapshot': 'pairs-paper 스냅샷 없음 (오늘 장 마감 후 생성)',
    'kiwoom.pairs.section.pairs': 'Pairs',
    'kiwoom.pairs.section.fillsToday': 'Fills today',
    'kiwoom.pairs.label.bankKbShinhan': '은행(KB-신한)',
    'kiwoom.pairs.label.bankKbHana': '은행(KB-하나)',
    'kiwoom.pairs.label.bankShinhanHana': '은행(신한-하나)',
    'kiwoom.pairs.label.telecomSktKt': '통신(SKT-KT)',
    'kiwoom.pairs.table.pairs.empty': '페어 없음',
    'kiwoom.pairs.table.fills.empty': '체결 없음',
    'kiwoom.pairs.table.pair': 'Pair',
    'kiwoom.pairs.table.side': 'Side',
    'kiwoom.pairs.table.z': 'Z',
    'kiwoom.pairs.table.hold': 'Hold',
    'kiwoom.pairs.table.symbol': 'Symbol',
    'kiwoom.pairs.table.qty': 'Qty',
    'kiwoom.currency.krw': '{n}원',
    'kiwoom.daytrading.subtitle.line1': 'KRX 테마-후발-dip 지정가 · paper',
    'kiwoom.daytrading.subtitle.line2': '장중 체결 · paper only',
    'kiwoom.daytrading.subtitle.line3': '실주문 없음 · EOD 시뮬 체결',
    'kiwoom.daytrading.placeholder': '⭐️키움단타가될지 빗썸이나 코인원이 될지는 모르겠으나 일단 섹션만 확보⭐️',
    'kiwoom.daytrading.legend.live': '실전 페이퍼',
    'kiwoom.daytrading.legend.backtest': '백테스트',
    'kiwoom.daytrading.awaiting': '첫 세션 대기 — 추석 연휴 후 재개',
    'kiwoom.daytrading.section.live': '실전 일별',
    'kiwoom.daytrading.section.backtest': '백테스트 일별 (in-sample · 컨텍스트)',
    'kiwoom.daytrading.section.trades': '체결',
    'kiwoom.daytrading.section.trades.count': '건',
    'kiwoom.daytrading.tab.live': '실전',
    'kiwoom.daytrading.tab.backtest': '백테스트',
    'kiwoom.daytrading.table.date': '날짜',
    'kiwoom.daytrading.table.signals': '신호',
    'kiwoom.daytrading.table.taken': '진입',
    'kiwoom.daytrading.table.win': '승률',
    'kiwoom.daytrading.table.equity': 'Equity',
    'kiwoom.daytrading.table.symbol': '종목',
    'kiwoom.daytrading.table.side': '방향',
    'kiwoom.daytrading.table.qty': '수량',
    'kiwoom.daytrading.table.trades.empty': '체결 없음',
    'kiwoom.daytrading.stat.equity.title': '실전 페이퍼 계좌 잔고 (100만 시작)',
    'kiwoom.daytrading.stat.start': '시작',
    'kiwoom.daytrading.stat.today': '당일',
    'kiwoom.daytrading.stat.dd.title': '피크 대비 잔고 밀림% · MDD는 기간 최대',
    'kiwoom.daytrading.disclaimer': 'in-sample 백테스트는 낙관적 — 실전 페이퍼(100만 시작)로 검증 중',
    'bithumb.spot.title': 'Spot Paper',
    'bithumb.spot.score': '성적',
    'bithumb.spot.score.aria': '성적',
    'bithumb.spot.detail': '상세',
    'bithumb.spot.liveStack': '라이브스택',
    'bithumb.spot.liveStack.detail': '라이브스택 상세',
    'bithumb.spot.liveStack.detailNote': '스팟 paper는 화면 책=주문 — mark_out@22–01 (Oct oracle). 표의 칸이 그 규칙이다.',
    'bithumb.spot.subtitle': 'mark_out@22–01 · no Core∪sat · tick entry · paper · WR target {target}%',
    'bithumb.spot.detail.hasMark': 'Has USDT-M mark',
    'bithumb.spot.subtitle.clusterWait': ' · awaiting cluster',
    'bithumb.spot.subtitle.updated': ' · updated {t}',
    'bithumb.spot.table.empty': 'No alerts',
    'bithumb.spot.stat.wrTarget': 'target {target}%',
    'bithumb.spot.stat.sum': 'Sum (price%)',
    'bithumb.spot.stat.stackN': 'stack n={n}',
    'bithumb.spot.status.ready': 'READY',
    'bithumb.spot.status.wait': 'WAIT',
    'bithumb.spot.status.expired': 'EXPIRED',
    'bithumb.spot.detail.sessionEnd': 'Session ended (past 02:00)',
    'bithumb.spot.detail.waitWindow': 'Waiting for entry window',
    'bithumb.spot.detail.notAllowlisted': 'Outside allowlist',
    'bithumb.spot.detail.q1hBlocked': 'sat q1h≥50',
    'bithumb.spot.detail.overshoot': 'Board overshoot',
    'bithumb.spot.detail.segRise': 'Segment rise {pct}%',
    'bithumb.spot.lane': 'Lane',
    'bithumb.spot.rule.entry': 'Entry',
    'bithumb.spot.rule.exit': 'Exit',
    'bithumb.spot.rule.order': 'Order',
    'bithumb.spot.allowlist.failed': 'Allowlist daily failed{detail}',
    'bithumb.spot.allowlist.stale': 'Allowlist daily stale — no success in 30h{detail}',
    'bithumb.spot.allowlist.missing': 'Allowlist status missing{detail}',
    'charts.back': '← 대시보드',
    'charts.title.live': '알림 심볼 · 24시간 1분봉',
    'charts.title.mountain': '{sym} 산 · 클러스터±24h',
    'charts.title.mountain36': '{sym} 산 · 클러스터±36h',
    'charts.title.mountainLate': '{sym} 산 · 저점 +10% ~ 고점 −20%',
    'charts.count': '{n}종목',
    'charts.noBars': '(+{n} 데이터 없음)',
    'charts.truncated': ' · 최근 40종목만',
    'charts.auto': '30초 자동갱신',
    'charts.lane.ready': '{lane} 레인 색으로 본다',
    'charts.lane.soon': '아직 데이터가 안 붙었다 (버튼만)',
    'charts.baseline': '기준',
    'charts.baseline.window': '창 시작',
    'charts.baseline.alert': '첫 알림',
    'charts.baseline.fire': '첫 발동',
    'charts.baseline.peak': '고점',
    'charts.hideAll': '전체 끄기',
    'charts.hideAll.title': '모든 선을 숨긴다',
    'charts.showAll': '전체 켜기',
    'charts.showAll.hidden': ' (숨김 {n})',
    'charts.showAll.title': '숨긴 선을 모두 되돌린다',
    'charts.live': '← 실시간으로',
    'charts.live.title': '과거창 보기를 접고 오늘~지금으로 돌아간다',
    'charts.ladder': '사다리',
    'charts.visionStrict': 'Vision ≥300%',
    'charts.hint.visionStrict': '1–7월 시가→고가 · 상장직후 포함',
    'charts.stop': '스탑',
    'charts.hint.liq': '캐스케이드 누적청산 ≥100 · LSK·IRYS만 진입·청산(초)',
    'charts.hint.bh': '라이브스택 6% · 직전 10분 +5%는 되돌림·체결',
    'charts.loss': '후반',
    'charts.hint.upbit': 'OI +30% · 고점 아래 5~15% · 9–10월',
    'charts.hint.gyeop': '직전 15초 +8% 이상 · 8·10월',
    'charts.gyeopFast': '8% 이상',
    'charts.hint.stair': 'LSK·IRYS급 · 숏청산/60s폭 진입 · trail8',
    'charts.stairFast': '급 롱전환',
    'charts.marker.exit': '청산',
    'charts.wait.entry': '{n}분 진입',
    'charts.wait.exit': '{n}분 청산',
    'charts.none': '없음',
    'charts.level.step': '{n}단',
    'charts.axis.lead': '세로축(로그)은 ',
    'charts.axis.base.window': '창 시작가(청캐=시가→고가)',
    'charts.axis.base.peak': '창 고점',
    'charts.axis.base.fire': '첫 발동가',
    'charts.axis.base.alert': '첫 알림가',
    'charts.axis.body': ' 대비 % (심볼마다 가격대가 달라 한 축에 겹치려면 %로 맞춰야 한다).',
    'charts.axis.peakNote': ' 고점 기준이면 현재값 = 고점 대비 낙폭(대시보드와 같은 기준).',
    'charts.axis.price': '가격은 Binance perp 마크가격 · 화살표 = 그 심볼의 {what} 시각.',
    'charts.what.liq': '청산 캐스케이드 발동',
    'charts.what.bh': '빗썸 알림·진입·스탑',
    'charts.what.upbit': '업비트 알림',
    'charts.what.upbitLoss': '후반 진입 · 210분',
    'charts.what.gyeop': '겹롱 진입·청산',
    'charts.what.stair': '급롱 진입·청산',
    'charts.window': ' · 창 ',
    'charts.mountainSpan': ' (산±24h)',
    'charts.span.gyeop': ' (진입±2분 · 틱)',
    'charts.span.liqFlip': ' (LSK·IRYS · 틱·초 · 진입·청산)',
    'charts.span.stair': ' (진입±30분 · 틱·초)',
    'charts.mountainSpan36': ' (산±36h)',
    'charts.mountainSpanLate': ' (이 건의 산)',
    'charts.updated': ' · 갱신 {t}',
    'charts.server': ' · 서버 {n}ms',
    'charts.laneSoonNote': ' · 이 레인은 아직 버튼만 있다',
    'charts.loading.mountain': '불러오는 중… 서버가 산±24h 창을 만드는 중이다 (완성되면 자동으로 뜬다 · {n}초째)',
    'charts.loading.mountain36': '불러오는 중… 서버가 산±36h 창을 만드는 중이다 (완성되면 자동으로 뜬다 · {n}초째)',
    'charts.loading.mountainLate': '불러오는 중… 서버가 이 건의 산을 만드는 중이다 (완성되면 자동으로 뜬다 · {n}초째)',
    'charts.loading.mountainShort': '불러오는 중… (산±24h — 서버가 백그라운드로 만든다)',
    'charts.loading.mountainShort36': '불러오는 중… (산±36h — 서버가 백그라운드로 만든다)',
    'charts.loading.mountainShortLate': '불러오는 중… (이 건의 산 — 서버가 백그라운드로 만든다)',
    'charts.loading.gyeop': '불러오는 중… (틱 · {n}초째)',
    'charts.loading.gyeopShort': '불러오는 중… (틱)',
    'charts.loading.first': '불러오는 중… (첫 로드는 서버가 24시간치를 펴느라 몇 초 걸린다)',
    'charts.empty.historic': '이 창엔 그릴 봉이 있는 {what} 심볼이 없다.',
    'charts.empty.today': '오늘(KST) 그릴 봉이 있는 {what} 심볼이 없다.',
    'charts.empty.what.liq': '청캐 발동',
    'charts.empty.what.bh': '스탑',
    'charts.empty.what.upbit': '업비트 알림',
    'charts.empty.what.gyeop': '겹롱',
    'charts.empty.what.stair': '급롱',
    'charts.empty.what.alert': '알림',
    'charts.stale': '정지 {h}h{m}m',
    'charts.legend.title': '{perp} · 봉 {bars} · {kind} {n}건\n현재가 {px}{warming}{note}\n클릭 = 숨기기/보이기',
    'charts.legend.kind.liq': '발동',
    'charts.legend.kind.alert': '알림',
    'charts.legend.warming': '\n(서버가 24시간치를 채우는 중)',
    'charts.noBarsLine': '봉 없음: ',
    'charts.err.server': '서버가 실패를 보고했다',
    'charts.err.ladder': '사다리 목록 조회 실패',
    'charts.marker.entry': '진입',
    'charts.marker.stop': '스탑',
    'charts.cum': '누적',
    'charts.mountainWord': '산',
    'charts.spanTitle': '창=산±24h',
    'charts.spanTitle36': '창=산±36h',
  },
  en: {
    'common.refresh': 'Refresh',
    'common.loading': 'Loading…',
    'common.close': 'Close',
    'common.tradeHistory': 'Trade history',
    'common.table.symbol': 'Symbol',
    'common.table.status': 'Status',
    'common.table.pnl': 'PnL',
    'common.table.detail': 'Detail',
    'common.table.entry': 'Entry',
    'common.table.exit': 'Exit',
    'common.table.reason': 'Reason',
    'common.table.side': 'Side',
    'common.table.qty': 'Qty',
    'common.table.pair': 'Pair',
    'common.table.hold': 'Hold',
    'dashboard.mobileTabs.ariaLabel': 'Exchanges',
    'alertType.segment_rise': 'Segment rise',
    'alertType.segment_fall': 'Segment fall',
    'alertType.short_term_rise': 'Short-term rise',
    'alertType.short_term_drop': 'Short-term drop',
    'alertType.buy_pressure': 'Buy pressure',
    'alertType.listing': 'Listing',
    'alertType.new_low': 'New low',
    'alertType.new_high': 'New high',
    'alertType.unknown': 'Other',
    'binance.subtitle.line1': 'Perpetuals on Binance USDⓈ-M',
    'binance.stat.filter': 'Details',
    'binance.stat.filter.viewCount': 'View {n}',
    'binance.stat.filter.title': 'View active filters (both lanes)',
    'binance.stat.available': 'Free margin',
    'binance.stat.available.title': 'Margin available for new entries. Initial margin already held by positions is excluded.',
    'binance.stat.weekPnl': 'This week P&L',
    'binance.stat.weekPnl.title': 'Whole account (shared by both lanes) · click for weekly realized P&L (both lanes combined — per-lane cumulative is in each lane P&L cell)',
    'binance.stat.weekPnl.tradeCount': '{n} trades',
    'binance.stat.drawdown': 'Drawdown',
    'binance.stat.drawdown.title': 'How far the balance has slipped since the mountain opened. (now/start − 1)×100.',
    'binance.stat.transfer': 'Transfer',
    'binance.stat.transfer.in': 'Deposit   ',
    'binance.stat.transfer.out': 'Withdraw',
    'binance.stat.transfer.title': 'Futures wallet TRANSFER total (USDT·USDC). Not trade P&L or swaps',
    'binance.stat.phone': 'Notifier',
    'binance.stat.phone.ok': 'OK',
    'binance.stat.phone.silent': 'Heartbeat lost',
    'binance.stat.phone.listenerOff': 'Notif access off',
    'binance.stat.phone.batteryOn': 'Battery opt on',
    'binance.stat.phone.title': 'Alert collect phone (notifier-android). Heartbeat every 3 min — if it stops, no alerts arrive',
    'binance.stat.trader': 'Trader',
    'binance.stat.trader.alive': 'Alive · {n}s',
    'binance.stat.trader.aliveNoAge': 'Alive',
    'binance.stat.trader.age': '{n}s',
    'binance.stat.trader.dead': 'Dead · {n}s',
    'binance.stat.trader.deadNoAge': 'Dead',
    'binance.stat.trader.stale': 'Stalled · {n}s',
    'binance.stat.trader.down': 'No response',
    'binance.stat.trader.title': 'Whether the process is running. Seconds are how stale the screen data is',
    'binance.stat.host.collect': 'Collect',
    'binance.stat.host.disk': 'Disk',
    'binance.stat.host.ok': 'OK',
    'binance.stat.host.down': 'Down',
    'binance.stat.host.unknown': 'Unknown',
    'binance.stat.host.free': 'Free {n}%',
    'binance.stat.host.mark': 'Mark',
    'binance.stat.host.agg': 'Trades',
    'binance.stat.host.spot': 'Spot',
    'binance.stat.host.oi': 'OI',
    'binance.stat.host.liq': 'Liq',
    'binance.stat.host.title': 'analyser continuous collect. Age of last mark · trades · spot · OI · liquidation row. Cut after 3 min (liquidations 10 min)',
    'binance.stat.host.diskTitle': 'analyser root disk free. Yellow under 25%, red under 15%',
    'binance.stat.equityCurve': 'Equity curve',
    'binance.stat.equityCurve.title': 'All-time equity curve (per trade, both lanes combined)',
    'binance.stat.upbit': 'Upbit',
    'binance.stat.upbit.title': 'Open/slots · wins/settled',
    'binance.stat.upbitPnl': 'Upbit P&L',
    'binance.stat.realizedPnl': 'Realized P&L',
    'binance.stat.realizedPnl.title': 'Realized P&L by lane (USDT). Upbit short · Bithumb short · Liq cascade · Pump ride · Dual short',
    'binance.lane.upbit': 'Upbit short',
    'binance.lane.bithumb': 'Bithumb short',
    'binance.lane.total': 'Total',
    'binance.lane.liq': 'Liq cascade',
    'binance.lane.candLong': 'Bithumb long',
    'binance.lane.pumpRide': 'Pump ride',
    'binance.lane.gyeopLong': 'Gyeop long',
    'binance.lane.stairLong': 'Stair long',
    'binance.lane.dualShort': 'Dual short',
    'binance.lane.inactive': 'inactive',
    'binance.lane.active': 'active',
    'binance.stat.slip': 'Slippage (measured)',
    'binance.stat.slip.title': 'Median entry slippage by lane (bp). Fill price − pre-order ref. Negative = adverse. Only counts fills with a real fill price (ref-substituted fills are 0 by definition and excluded). Backtests use 10bp round-trip fees and 0 slippage — this is the gap vs that assumption',
    'binance.stat.slip.roundtrip': 'Round-trip est.',
    'binance.stat.timing': 'Lane timing (peak · entry · hold)',
    'binance.stat.timing.title': 'Minutes from alert to Binance peak (t_peak). Top 3 lines are weekly medians (trend); peak below is rolling median of last N trades with 95% CI (N shown as n beside, yaml lane_timing_roll_n) — cutting at week boundaries drops sample to single digits early week so 1–2 trades swing ±10 min. On 2026-08-10 t_peak shifted +4→+32 min; that was the core-lane collapse (Mann-Whitney z −4.51). Pump amplitude and alert % into the pump were unchanged — same-size pumps got slower. **Judgment is not whether entry delay equals t_peak**: if median is T, half peak after T, so entering at T means half are still rising (measured: at t_peak 32, delay 20 min −0.352% / 60 min +1.288%). Danger is when delay is **less** than t_peak. Moves before P&L',
    'binance.stat.timing.implied': 'Implied',
    'binance.stat.timing.peak': 'Peak',
    'binance.stat.timing.deployed': 'Entry',
    'binance.stat.timing.hold': 'Hold',
    'binance.stat.timing.match': '✓ After peak',
    'binance.stat.timing.mismatch': 'Mismatch',
    'binance.stat.timing.early': '⚠ Before peak',
    'binance.stat.timing.late': '⚠ Too late',
    'binance.stat.lanes': 'Lanes · open/k · wins/settled',
    'binance.stat.lanes.title': 'Per lane open/slots · wins/settled. Liq lane also shows fires vs entries (gap = blocked by slots/capital)',
    'binance.stat.lanesSize': 'Lanes · lev/notional',
    'binance.stat.lanesSize.title': 'Effective leverage and notional per trade (USDT) by lane',
    'binance.stat.lanes.col.lane': 'Lane',
    'binance.stat.lanes.col.status': 'Status',
    'binance.stat.lanes.col.hold': 'Open/k',
    'binance.stat.lanes.col.legs': 'Legs',
    'binance.stat.lanes.col.wins': 'Wins/settled',
    'binance.stat.lanes.col.pnl.hint': 'Click for sum',
    'binance.stat.lanes.col.lev': 'lev',
    'binance.stat.lanes.col.notional': 'Notional',
    'binance.stat.lanes.col.timing': 'Hold',
    'binance.stat.lanes.col.stop': 'Stop',
    'binance.stat.lanes.col.strategy': 'Strategy',
    'binance.stat.lanes.col.strategy.hint': 'Sub-strategies this lane uses now. Same order as hold · stop columns.',
    'binance.stat.lanes.col.stop.hint': 'Price stop %. Upbit short: evening/mountain. Mountain also has +15% · OI−2% market exit (title).',
    'binance.stat.lanes.col.liveStats.hint': 'Current config (config_id) settlements · else latest stamped config fallback — live_ledger.',
    'binance.stat.lanes.col.liveStats.title': 'Current config · n={n} · avg {avg} · win rate {win} · {pnl} USDT · id {id}',
    'binance.stat.lanes.col.liveStats.empty': 'No settlements under this config (post-deploy · id-mismatched old trades excluded)',
    'binance.stat.liq.fired': 'Fired {n} → entered {entered}',
    'binance.regime.col.week': 'Week',
    'binance.stat.upbitPnl.title': 'Upbit lane realized P&L (cumulative)',
    'binance.stat.upbitLev': 'Upbit lev/notional',
    'binance.stat.upbitLev.title': 'Effective fill leverage / requested · notional per trade (Upbit risk sizing)',
    'binance.stat.bithumb': 'Bithumb',
    'binance.stat.bithumb.title': 'Open/slots · wins/settled',
    'binance.stat.bithumb.off': 'Off',
    'binance.stat.bithumbPnl': 'Bithumb P&L',
    'binance.stat.bithumbPnl.title': 'Bithumb sleeve realized P&L (cumulative)',
    'binance.stat.bithumbLev': 'Bithumb lev/notional',
    'binance.stat.bithumbLev.title': 'Effective fill leverage · base notional and 1m volume cap (sizing differs from Upbit)',
    'binance.tradeHistory.enteredOnly': 'Entered (planned)',
    'binance.tradeHistory.enteredOnly.title.hidden': 'Only WATCH (incl. liq cascade watch) + entered rows (OPEN/EXIT) · {n} ended-watch/skip rows hidden',
    'binance.tradeHistory.enteredOnly.title.all': 'Also show ended watches and skip rows',
    'binance.tradeHistory.neededOnly': 'Needed',
    'binance.tradeHistory.neededOnly.title.hidden': 'Only Upbit + Bithumb new highs · {n} collect/unparsed rows hidden',
    'binance.tradeHistory.neededOnly.title.all': 'Also show collect-only alerts',
    'binance.tradeHistory.title': 'Trade history',
    'binance.table.header.symbol': 'Symbol',
    'binance.table.header.status': 'Status',
    'binance.table.header.alert': 'Alert',
    'binance.table.header.sizing': 'Sizing',
    'binance.table.header.chart': 'Charts',
    'binance.table.header.pnl': 'PnL',
    'binance.manualClose.button': 'Close',
    'binance.manualClose.confirm': 'Sure?',
    'binance.manualClose.working': 'Requesting…',
    'binance.manualClose.queued': 'Queued · sell within {eta}s',
    'binance.manualClose.cancelled': 'Cancelled',
    'binance.manualClose.failed': 'Failed: {error}',
    'binance.manualClose.title': 'Sell {perp} now. After passkey (Face ID/Touch ID), the bot sells on the next cycle.',
    'binance.manualEntry.button': 'Enter',
    'binance.manualEntry.confirm': 'Sure?',
    'binance.manualEntry.working': 'Requesting…',
    'binance.manualEntry.queued': 'Queued · enter within {eta}s',
    'binance.manualEntry.entered': 'Succeeded',
    'binance.manualEntry.failed': 'Failed: {error}',
    'binance.manualEntry.timeout': 'Result delayed — check the table',
    'binance.manualEntry.reason.lane_busy': '{holder} lane already holding',
    'binance.manualEntry.reason.lane_busy.unknown': 'Another lane already holding',
    'binance.manualEntry.holder.liq': 'Liq',
    'binance.manualEntry.holder.upbit': 'Upbit short',
    'binance.manualEntry.holder.bh': 'Bithumb',
    'binance.manualEntry.holder.cl': 'Bithumb long',
    'binance.manualEntry.holder.long': 'Long',
    'binance.manualEntry.holder.orphan': 'Exchange orphan',
    'binance.manualEntry.reason.margin': 'Insufficient margin',
    'binance.manualEntry.reason.liq_reserve': 'Liq lane margin reserved',
    'binance.manualEntry.reason.liq_priority': 'Liq cascade priority · Upbit short yields',
    'binance.manualEntry.reason.already_open': 'Same symbol already held in Upbit short',
    'binance.manualEntry.reason.slot_full': 'Slots full',
    'binance.manualEntry.reason.late': 'Wait window expired',
    'binance.manualEntry.reason.halted': 'Trader halted',
    'binance.manualEntry.reason.min_notional': 'Below min notional',
    'binance.manualEntry.reason.capacity': 'Capacity exceeded',
    'binance.manualEntry.reason.entry_fail': 'Order failed',
    'binance.manualEntry.reason.no_pullback': 'No pullback',
    'binance.manualEntry.reason.runup_low': 'Runup too low',
    'binance.manualEntry.reason.rv_low': 'Volatility too low',
    'binance.manualEntry.reason.no_drop': 'Insufficient drop',
    'binance.manualEntry.reason.kr_segment_high': 'KR segment-high gate',
    'binance.manualEntry.reason.hot_ban': 'Re-short banned after abort/no_pullback',
    'binance.manualEntry.reason.scout_run_hi': 'First of day · watch too high (scout)',
    'binance.manualEntry.title': 'Enter {perp} now. After passkey, the bot orders without waiting for pullback.',
    'binance.table.header.detail': 'Detail',
    'binance.table.header.exchange.title': 'Exchange',
    'binance.table.header.lane.title': 'Lane',
    'binance.table.empty': 'No events',
    'binance.exchange.short.upbit': 'Up',
    'binance.exchange.short.bithumb': 'Bi',
    'binance.exchange.short.coinone': 'Co',
    'binance.exchange.full.upbit': 'Upbit',
    'binance.exchange.full.bithumb': 'Bithumb',
    'binance.exchange.full.coinone': 'Coinone',
    'binance.exchange.full.unknown': 'Unknown',
    'binance.status.alert': 'ALERT',
    'binance.status.trigger': 'TRIGGER',
    'binance.status.pending': 'PENDING',
    'binance.status.exit': 'EXIT',
    'binance.status.open': 'OPEN',
    'binance.status.skip': 'SKIP',
    'binance.status.short': 'SHORT',
    'binance.status.reshort': 'RESHORT',
    'binance.status.long': 'LONG',
    'binance.status.fail': 'FAIL',
    'binance.status.collect': 'COLLECT',
    'binance.status.watch': 'WATCH',
    'binance.status.watchEnd': 'Watch end',
    'binance.pnl.fee': 'Fees {amount}',
    'binance.pnl.funding': 'Funding {amount}',
    'binance.skipPnl.stopped': 'Stop',
    'binance.skipPnl.held': 'Held {min} min',
    'binance.skipPnl.pullbackHeld': 'Watch {watch} · hold {hold} min',
    'binance.skipPnl.noPullback': 'No pullback',
    'binance.skipPnl.watchOnly': 'Watch {watch} min',
    'binance.skipPnl.coarse': '1m-bar estimate',
    'binance.skipPnl.title': 'Hypothetical P&L of an unentered trade ({lane} · {reason} · {bucket}). Not a real fill. Chart is price path vs alert price.',
    'binance.skipReport.title': 'Counterfactual P&L by filter',
    'binance.skipReport.window': 'All {days} days',
    'binance.skipReport.capacity': 'Capacity',
    'binance.regime.title': '',
    'binance.regime.hint': 'live_ledger live trades — ISO week (KST) · per-lane avg % · win rate %(n). Settles to DB immediately · 30s poll. Not counterfactual regime_weekly.',
    'binance.liqVitality.dead': 'DEAD',
    'binance.liqVitality.marginal': 'MARGINAL',
    'binance.liqVitality.alive': 'ALIVE',
    'binance.liqVitality.unknown': '–',
    'binance.liqVitality.live.off': 'Keep OFF',
    'binance.liqVitality.live.hold': 'HOLD',
    'binance.liqVitality.live.discuss': 'Discuss turning on',
    'binance.liqVitality.live.keep': 'Keep',
    'binance.liqVitality.live.turn_off': 'Recommend OFF',
    'binance.liqVitality.roll': 'N{n}',
    'binance.liqVitality.hint': 'liq_trigger rolling score (effective pullback · fees · rescue). avg_net<0 or ratio<1.05→dead; avg>0 · ratio≥1.5 · n≥20→alive. No auto yaml changes.',
    'binance.abortReport.title': 'abort counterfactual — if not cut',
    'binance.stopReport.title': 'Stop counterfactual — without stop',
    'binance.stopReport.empty': '0 stops. When a stop-out happens it lands here vs "held 30 min without stop" (no retroactive).',
    'binance.stopReport.compare': 'Stop avg {actual} vs {base} if held 30 min without stop',
    'binance.longReport.title': 'Long-flip counterfactual — without exit rule',
    'binance.longReport.empty': '0 long flips. When abort cuts a short and opens a long, it lands here vs "held 30 min without new-high stall exit" (hard stop −2% kept).',
    'binance.longReport.compare': 'Long realized avg {actual} vs {base} if held without exit rule',
    'binance.longSkipReport.title': 'Long skip counterfactual — if opened',
    'binance.longSkipReport.empty': '0 cases where abort cut the short but no long was opened.',
    'binance.longSkipReport.compare': '{n} trades not opened. If opened: avg {base} (sum {sum}p) — negative if skipping cost money.',
    'binance.abortReport.empty': '0 abort fires. Two legs, OR — fast price reversal, or OI spike with sustained buy pressure. Exact thresholds/windows are in the abort row of the filter list above (yaml is source of truth).',
    'binance.abortReport.saved': 'abort won on {saved} of {n} trades.',
    'binance.abortReport.sum': 'sum {sum}p',
    'binance.abortReport.compare': 'abort avg {actual} vs {base} if not cut',
    'binance.abortReport.stopRate': 'Share that would have hit the 6% stop if not cut: {rate}',
    'binance.abortReport.pending': '{n} trades pending score (30 min virtual hold in progress)',
    'binance.abortReport.note': 'Diff > 0 means abort avoided a loss; < 0 means it cut a gain. Price source: collected markPrice@1s.',
    'binance.abortReport.legTitle': 'By leg',
    'binance.abortReport.legCol.leg': 'Leg',
    'binance.abortReport.legCellTitle': '{label} — {hint}',
    'binance.flipReport.title': 'flip counterfactual — without flip',
    'binance.flipReport.col.type': 'Flip type',
    'binance.flipReport.col.count': 'Fires',
    'binance.flipReport.col.betterRate': 'Flip wins',
    'binance.flipReport.col.avgDelta': 'Δ per trade',
    'binance.flipReport.col.sumDelta': 'Net contrib',
    'binance.flipReport.col.avgBase': 'Without flip',
    'binance.flipReport.col.avgTotal': 'Actual',
    'binance.flipReport.emptyOn': '0 fires. Flips on: {on} — ⚠️ but fires are not recorded (record_flip unwired). So this is "unknown", not "none hit".',
    'binance.flipReport.emptyOff': '0 fires — no flip is on.',
    'binance.flipReport.pending': '{n} trades pending score (long leg in progress)',
    'binance.flipReport.note': 'Net contrib = actual (short leg + long leg) − without flip (short only). >0 means flip helped; <0 means the short should have been left alone.',
    'binance.skipReport.lane.deployed': 'Deployed line',
    'binance.skipReport.lane.research': 'Research',
    'binance.skipReport.col.filter': 'Filter',
    'binance.skipReport.col.count': 'Count',
    'binance.skipReport.col.avg': 'Per trade',
    'binance.skipReport.col.sum': 'Sum',
    'binance.skipReport.col.winRate': 'Win rate',
    'binance.skipReport.col.stopRate': 'Stop rate',
    'binance.skipReport.verdict.costly': 'Rejected {n} trades sum to {sum}% — the filter discarded that much.',
    'binance.skipReport.verdict.worth': 'Rejected {n} trades sum to {sum}% — the filter blocked that much.',
    'binance.skipReport.note': 'Entry alert+1 min / exit +30 min / 6% stop, scored with live rules. Capacity rows (slots full, etc.) are not filter quality and are excluded from the sum.',
    'binance.sizing.risk': '{pct}%',
    'binance.pnlModal.title': 'Realized P&L',
    'binance.pnlModal.note': 'KST. Realized fill P&L, not backtest.',
    'binance.pnlModal.empty': 'No closed trades.',
    'binance.pnlModal.col.period': 'Period',
    'binance.pnlModal.col.count': 'Count',
    'binance.pnlModal.col.winRate': 'Win rate',
    'binance.pnlModal.col.stops': 'Stops',
    'binance.pnlModal.col.perTrade': 'Per trade',
    'binance.pnlModal.section.thisWeekDaily': 'This week by day ({start} ~)',
    'binance.pnlModal.section.weekly': 'By week',
    'binance.pnlModal.inProgress': 'In progress',
    'binance.pnlModal.total': 'Grand total',
    'binance.filterModal.title': 'Filters currently applied',
    'binance.filterModal.note': 'Values read from the deployed config — the running bot, not the docs.',
    'binance.filterModal.lane.common': 'Shared — both lanes',
    'binance.filterModal.lane.upbit': 'Upbit short',
    'binance.filterModal.lane.bh': 'Bithumb short',
    'binance.filterModal.lane.liq': 'Liq cascade',
    'binance.filterModal.count': '{n}',
    'binance.filter.effect.skip': 'Drop alert',
    'binance.filter.effect.entry': 'Entry timing',
    'binance.filter.effect.size': 'Size adjust',
    'binance.filter.effect.collect': 'Collect only',
    'binance.filter.effect.sleeve': 'Separate lane',
    'binance.filter.effect.exit': 'Exit rule',
    'binance.filter.effect.pending': 'Pending — revalidate later',
    'binance.filter.effect.label_only': 'Simulation — no orders',
    'binance.skipReport.newlistingSim': 'New-listing exemption sim (no orders)',
    'binance.newlistingReport.title': 'New-listing exemption counterfactual — if exempted',
    'binance.newlistingReport.empty': '0 labels. Fills when an Upbit listing within {days} days fails the runup floor (no retroactive).',
    'binance.newlistingReport.sum': '{n} trades · sum {sum}p · {avg} per trade',
    'binance.newlistingReport.rate': 'Win rate {win} · stop rate {stop}',
    'binance.newlistingReport.pending': '{n} trades pending score',
    'binance.newlistingReport.gate': 'Judgment line n≥{need} — label only for now, no orders.',
    'binance.segmentHighReport.title': 'segment_high counterfactual (skip ≥40%) — if opened',
    'binance.segmentHighReport.empty': '0 scored segment_high skips.',
    'binance.segmentHighReport.sum': '{n} trades · sum {sum}p · {avg} per trade',
    'binance.segmentHighReport.rate': 'Win rate {win} · stop rate {stop}',
    'binance.segmentHighReport.abort': 'abort rebuilt {scored} trades, fired {fired}',
    'binance.segmentHighReport.abortHint': 'Cold-tier rebuild only (ticks present, from 2026-08-02) and stops only. 0/N means abort blocked none of these stops — a segment_pct spike is a slow rise, a structural blind spot of the abort (second-scale spike detector) (appendix A).',
    'binance.segmentHighReport.runupTitle': 'runup_60m_pct bands (fast/slow rise axis)',
    'binance.segmentHighReport.segmentTitle': 'segment_pct bands (40–50 / ≥50)',
    'binance.segmentHighReport.col.band': 'Band',
    'binance.segmentHighReport.gate.judged': 'Judgment line n≥{need} met — still check fat-tail single-symbol dependence separately.',
    'binance.segmentHighReport.gate.notJudged': 'Not judged — n={n}, line n≥{need}. Forward collecting (doc stream-upbit-segment-high-runup-short-2026-08-06 §conclusion).',
    'ibkr.swing.subtitle.line1': 'MES·MNQ·MGC·ZN daily long · paper',
    'ibkr.swing.subtitle.line2': 'Sun–Thu 18:15 ET rebalance',
    'ibkr.swing.subtitle.line3': 'Globex Sun 18:00–Fri 17:00 ET · closed 17–18 ET',
    'ibkr.swing.legs.empty': 'No legs',
    'ibkr.swing.section.legs': 'Legs',
    'ibkr.swing.trades.empty': 'No trades',
    'ibkr.tfsa.subtitle.line1': 'TipRanks analyst confirm filter (2/3)',
    'ibkr.tfsa.subtitle.line2': 'rank≤50 upgrade · stock SR≥70%',
    'ibkr.tfsa.subtitle.line3': 'upside≥15% · no orders (paper)',
    'ibkr.tfsa.table.empty': 'No logs',
    'ibkr.tfsa.section.analystFilter': 'Analyst filter',
    'ibkr.tfsa.table.ticker': 'Ticker',
    'ibkr.tfsa.table.signal': 'Signal',
    'ibkr.tfsa.table.analyst': 'Analyst',
    'ibkr.tfsa.table.sr': 'SR',
    'ibkr.tfsa.table.upside': 'Upside',
    'ibkr.tfsa.table.conv': 'Conv',
    'kiwoom.pairs.subtitle.line1': 'KRX bank·telecom z-score pairs',
    'kiwoom.pairs.subtitle.line2': 'EOD 16:05 KST · paper only',
    'kiwoom.pairs.subtitle.line3': 'No orders · sim fills only',
    'kiwoom.pairs.noSnapshot': "No pairs-paper snapshot (created after today's close)",
    'kiwoom.pairs.section.pairs': 'Pairs',
    'kiwoom.pairs.section.fillsToday': 'Fills today',
    'kiwoom.pairs.label.bankKbShinhan': 'Banks (KB-Shinhan)',
    'kiwoom.pairs.label.bankKbHana': 'Banks (KB-Hana)',
    'kiwoom.pairs.label.bankShinhanHana': 'Banks (Shinhan-Hana)',
    'kiwoom.pairs.label.telecomSktKt': 'Telecom (SKT-KT)',
    'kiwoom.pairs.table.pairs.empty': 'No pairs',
    'kiwoom.pairs.table.fills.empty': 'No fills',
    'kiwoom.pairs.table.pair': 'Pair',
    'kiwoom.pairs.table.side': 'Side',
    'kiwoom.pairs.table.z': 'Z',
    'kiwoom.pairs.table.hold': 'Hold',
    'kiwoom.pairs.table.symbol': 'Symbol',
    'kiwoom.pairs.table.qty': 'Qty',
    'kiwoom.currency.krw': '{n} KRW',
    'kiwoom.daytrading.subtitle.line1': 'KRX theme-follower-dip limit · paper',
    'kiwoom.daytrading.subtitle.line2': 'Intraday fills · paper only',
    'kiwoom.daytrading.subtitle.line3': 'No live orders · EOD sim fills',
    'kiwoom.daytrading.placeholder': '⭐️ Not sure if this becomes Kiwoom day-trading, Bithumb, or Coinone — section reserved for now ⭐️',
    'kiwoom.daytrading.legend.live': 'Live paper',
    'kiwoom.daytrading.legend.backtest': 'Backtest',
    'kiwoom.daytrading.awaiting': 'Awaiting first session — resumes after Chuseok holiday',
    'kiwoom.daytrading.section.live': 'Live daily',
    'kiwoom.daytrading.section.backtest': 'Backtest daily (in-sample · context)',
    'kiwoom.daytrading.section.trades': 'Fills',
    'kiwoom.daytrading.section.trades.count': 'trades',
    'kiwoom.daytrading.tab.live': 'Live',
    'kiwoom.daytrading.tab.backtest': 'Backtest',
    'kiwoom.daytrading.table.date': 'Date',
    'kiwoom.daytrading.table.signals': 'Signals',
    'kiwoom.daytrading.table.taken': 'Entries',
    'kiwoom.daytrading.table.win': 'Win rate',
    'kiwoom.daytrading.table.equity': 'Equity',
    'kiwoom.daytrading.table.symbol': 'Symbol',
    'kiwoom.daytrading.table.side': 'Side',
    'kiwoom.daytrading.table.qty': 'Qty',
    'kiwoom.daytrading.table.trades.empty': 'No fills',
    'kiwoom.daytrading.stat.equity.title': 'Live paper account equity (1M start)',
    'kiwoom.daytrading.stat.start': 'Start',
    'kiwoom.daytrading.stat.today': 'Today',
    'kiwoom.daytrading.stat.dd.title': 'Equity drawdown % from peak · MDD is period max',
    'kiwoom.daytrading.disclaimer': 'In-sample backtest is optimistic — validating on live paper (1M start)',
    'bithumb.spot.title': 'Spot Paper',
    'bithumb.spot.score': 'Score',
    'bithumb.spot.score.aria': 'Score',
    'bithumb.spot.detail': 'Detail',
    'bithumb.spot.liveStack': 'Live stack',
    'bithumb.spot.liveStack.detail': 'Live stack detail',
    'bithumb.spot.liveStack.detailNote': 'Spot paper: screen book = orders — mark_out@22–01 (Oct oracle). Table cells are those rules one by one.',
    'bithumb.spot.subtitle': 'mark_out@22–01 · no Core∪sat · tick entry · paper · WR target {target}%',
    'bithumb.spot.detail.hasMark': 'Has USDT-M mark',
    'bithumb.spot.subtitle.clusterWait': ' · awaiting cluster',
    'bithumb.spot.subtitle.updated': ' · updated {t}',
    'bithumb.spot.table.empty': 'No alerts',
    'bithumb.spot.stat.wrTarget': 'target {target}%',
    'bithumb.spot.stat.sum': 'Sum (price%)',
    'bithumb.spot.stat.stackN': 'stack n={n}',
    'bithumb.spot.status.ready': 'READY',
    'bithumb.spot.status.wait': 'WAIT',
    'bithumb.spot.status.expired': 'EXPIRED',
    'bithumb.spot.detail.sessionEnd': 'Session ended (past 02:00)',
    'bithumb.spot.detail.waitWindow': 'Waiting for entry window',
    'bithumb.spot.detail.notAllowlisted': 'Outside allowlist',
    'bithumb.spot.detail.q1hBlocked': 'sat q1h≥50',
    'bithumb.spot.detail.overshoot': 'Board overshoot',
    'bithumb.spot.detail.segRise': 'Segment rise {pct}%',
    'bithumb.spot.lane': 'Lane',
    'bithumb.spot.rule.entry': 'Entry',
    'bithumb.spot.rule.exit': 'Exit',
    'bithumb.spot.rule.order': 'Order',
    'bithumb.spot.allowlist.failed': 'Allowlist daily failed{detail}',
    'bithumb.spot.allowlist.stale': 'Allowlist daily stale — no success in 30h{detail}',
    'bithumb.spot.allowlist.missing': 'Allowlist status missing{detail}',
    'charts.back': '← Dashboard',
    'charts.title.live': 'Alert symbols · 24h 1m bars',
    'charts.title.mountain': '{sym} mountain · cluster ±24h',
    'charts.title.mountain36': '{sym} mountain · cluster ±36h',
    'charts.title.mountainLate': '{sym} mountain · trough +10% ~ peak −20%',
    'charts.count': '{n} symbols',
    'charts.noBars': '(+{n} no data)',
    'charts.truncated': ' · last 40 symbols only',
    'charts.auto': 'Auto-refresh 30s',
    'charts.lane.ready': 'View in {lane} lane colors',
    'charts.lane.soon': 'No data attached yet (button only)',
    'charts.baseline': 'Base',
    'charts.baseline.window': 'Window start',
    'charts.baseline.alert': 'First alert',
    'charts.baseline.fire': 'First fire',
    'charts.baseline.peak': 'Peak',
    'charts.hideAll': 'Hide all',
    'charts.hideAll.title': 'Hide all lines',
    'charts.showAll': 'Show all',
    'charts.showAll.hidden': ' (hidden {n})',
    'charts.showAll.title': 'Restore all hidden lines',
    'charts.live': '← Live',
    'charts.live.title': 'Close historic window and return to today→now',
    'charts.ladder': 'Ladder',
    'charts.visionStrict': 'Vision ≥300%',
    'charts.hint.visionStrict': 'Jan–Jul open→high · incl. fresh listings',
    'charts.stop': 'Stop',
    'charts.hint.liq': 'Cascade cum liq ≥100 · LSK·IRYS only entry·exit (sec)',
    'charts.hint.bh': 'Live stack 6% · prior 10 min +5% on pullback · fill',
    'charts.loss': 'Late',
    'charts.hint.upbit': 'OI +30% · 5–15% under peak · Sep–Oct',
    'charts.hint.gyeop': 'Prior 15s ≥+8% · Aug·Oct',
    'charts.gyeopFast': '≥8%',
    'charts.hint.stair': 'LSK·IRYS-class · short-liq/60s-range entry · trail8',
    'charts.stairFast': 'Fast long flip',
    'charts.marker.exit': 'Exit',
    'charts.wait.entry': '{n} min entry',
    'charts.wait.exit': '{n} min exit',
    'charts.none': 'None',
    'charts.level.step': 'Step {n}',
    'charts.axis.lead': 'Y-axis (log) is ',
    'charts.axis.base.window': 'Window start (liq cascade = open→high)',
    'charts.axis.base.peak': 'Window peak',
    'charts.axis.base.fire': 'First fire price',
    'charts.axis.base.alert': 'First alert price',
    'charts.axis.body': ' vs % (symbols have different price levels, so % is needed to share one axis).',
    'charts.axis.peakNote': ' With peak base, current = drawdown from peak (same basis as the dashboard).',
    'charts.axis.price': 'Price is Binance perp mark · arrow = {what} time for that symbol.',
    'charts.what.liq': 'Liq cascade fire',
    'charts.what.bh': 'Bithumb alert·entry·stop',
    'charts.what.upbit': 'Upbit alert',
    'charts.what.upbitLoss': 'Late entry · 210 min',
    'charts.what.gyeop': 'Gyeop long entry·exit',
    'charts.what.stair': 'Stair long entry·exit',
    'charts.window': ' · window ',
    'charts.mountainSpan': ' (mountain ±24h)',
    'charts.span.gyeop': ' (entry ±2 min · tick)',
    'charts.span.liqFlip': ' (LSK·IRYS · tick·sec · entry·exit)',
    'charts.span.stair': ' (entry ±30 min · tick·sec)',
    'charts.mountainSpan36': ' (mountain ±36h)',
    'charts.mountainSpanLate': ' (mountain for this trade)',
    'charts.updated': ' · updated {t}',
    'charts.server': ' · server {n}ms',
    'charts.laneSoonNote': ' · this lane still has button only',
    'charts.loading.mountain': 'Loading… server building mountain ±24h window (auto-shows when ready · {n}s)',
    'charts.loading.mountain36': 'Loading… server building mountain ±36h window (auto-shows when ready · {n}s)',
    'charts.loading.mountainLate': 'Loading… server building mountain for this trade (auto-shows when ready · {n}s)',
    'charts.loading.mountainShort': 'Loading… (mountain ±24h — server builds in background)',
    'charts.loading.mountainShort36': 'Loading… (mountain ±36h — server builds in background)',
    'charts.loading.mountainShortLate': 'Loading… (mountain for this trade — server builds in background)',
    'charts.loading.gyeop': 'Loading… (tick · {n}s)',
    'charts.loading.gyeopShort': 'Loading… (tick)',
    'charts.loading.first': 'Loading… (first load expands 24h on the server; a few seconds)',
    'charts.empty.historic': 'No {what} symbols with bars to draw in this window.',
    'charts.empty.today': 'No {what} symbols with bars to draw today (KST).',
    'charts.empty.what.liq': 'liq cascade fire',
    'charts.empty.what.bh': 'stop',
    'charts.empty.what.upbit': 'Upbit alert',
    'charts.empty.what.gyeop': 'Gyeop long',
    'charts.empty.what.stair': 'Stair long',
    'charts.empty.what.alert': 'alert',
    'charts.stale': 'Stale {h}h{m}m',
    'charts.legend.title': "{perp} · bars {bars} · {kind} {n}\nprice {px}{warming}{note}\nclick = hide/show",
    'charts.legend.kind.liq': 'Fires',
    'charts.legend.kind.alert': 'Alerts',
    'charts.legend.warming': "\n(server filling 24h)",
    'charts.noBarsLine': 'No bars: ',
    'charts.err.server': 'Server reported failure',
    'charts.err.ladder': 'Failed to fetch ladder list',
    'charts.marker.entry': 'Entry',
    'charts.marker.stop': 'Stop',
    'charts.cum': 'Cum',
    'charts.mountainWord': 'Mountain',
    'charts.spanTitle': 'Window=mountain ±24h',
    'charts.spanTitle36': 'Window=mountain ±36h',
  },
  fr: {
    'common.refresh': 'Actualiser',
    'common.loading': 'Chargement…',
    'common.close': 'Fermer',
    'common.tradeHistory': 'Historique',
    'common.table.symbol': 'Symbole',
    'common.table.status': 'Statut',
    'common.table.pnl': 'PnL',
    'common.table.detail': 'Détail',
    'common.table.entry': 'Entrée',
    'common.table.exit': 'Sortie',
    'common.table.reason': 'Raison',
    'common.table.side': 'Côté',
    'common.table.qty': 'Qté',
    'common.table.pair': 'Paire',
    'common.table.hold': 'Dét.',
    'dashboard.mobileTabs.ariaLabel': 'Bourses',
    'alertType.segment_rise': 'Hausse segment',
    'alertType.segment_fall': 'Baisse segment',
    'alertType.short_term_rise': 'Hausse rapide',
    'alertType.short_term_drop': 'Chute rapide',
    'alertType.buy_pressure': 'Pression acheteuse',
    'alertType.listing': 'Cotation',
    'alertType.new_low': 'Nouveau plus bas',
    'alertType.new_high': 'Nouveau plus haut',
    'alertType.unknown': 'Autre',
    'binance.subtitle.line1': 'Perpétuel Binance USDⓈ-M',
    'binance.stat.filter': 'Détails',
    'binance.stat.filter.viewCount': 'Voir {n}',
    'binance.stat.filter.title': 'Voir les filtres actifs (les deux manches)',
    'binance.stat.available': 'Marge libre',
    'binance.stat.available.title': 'Marge disponible pour une nouvelle entrée. La marge initiale déjà prise par les positions est exclue.',
    'binance.stat.weekPnl': 'Cette semaine',
    'binance.stat.weekPnl.title': 'Compte global (commun aux deux manches) · cliquer pour voir le PnL hebdomadaire (total des deux manches)',
    'binance.stat.weekPnl.tradeCount': '{n}',
    'binance.stat.drawdown': 'Repli',
    'binance.stat.drawdown.title': 'Écart du solde depuis l\'ouverture de la montagne. (maintenant/départ − 1)×100.',
    'binance.stat.transfer': 'Transfer',
    'binance.stat.transfer.in': 'Dépôt TRANSFER',
    'binance.stat.transfer.out': 'Retrait TRANSFER',
    'binance.stat.transfer.title': 'Total TRANSFER du portefeuille futures, hors P&L',
    'binance.stat.phone': 'Notifier',
    'binance.stat.phone.ok': 'OK',
    'binance.stat.phone.silent': 'Silence',
    'binance.stat.phone.listenerOff': 'Accès notifications coupé',
    'binance.stat.phone.batteryOn': 'Optimisation batterie active',
    'binance.stat.phone.title': "Téléphone collecteur (notifier-android). Battement toutes les 3 min — s'il s'arrête, plus aucune alerte n'arrive",
    'binance.stat.trader': 'Trader',
    'binance.stat.trader.alive': 'En vie · {n}s',
    'binance.stat.trader.aliveNoAge': 'En vie',
    'binance.stat.trader.age': '{n}s',
    'binance.stat.trader.dead': 'Mort · {n}s',
    'binance.stat.trader.deadNoAge': 'Mort',
    'binance.stat.trader.stale': 'Arrêt · {n}s',
    'binance.stat.trader.down': 'Pas de réponse',
    'binance.stat.trader.title': 'Processus running ou non. Les secondes sont l\'âge des données affichées',
    'binance.stat.host.collect': 'Collecte',
    'binance.stat.host.disk': 'Disque',
    'binance.stat.host.ok': 'OK',
    'binance.stat.host.down': 'coupé',
    'binance.stat.host.unknown': 'illisible',
    'binance.stat.host.free': 'libre {n}%',
    'binance.stat.host.mark': 'mark',
    'binance.stat.host.agg': 'trades',
    'binance.stat.host.spot': 'spot',
    'binance.stat.host.oi': 'OI',
    'binance.stat.host.liq': 'liq',
    'binance.stat.host.title': 'Collecte permanente de l\'analyseur. Âge de la dernière ligne mark, trades, spot, OI, liquidations. Coupé après 3 min (liquidations 10 min)',
    'binance.stat.host.diskTitle': 'Espace libre sur le disque racine de l\'analyseur. Jaune sous 25 %, rouge sous 15 %',
    'binance.stat.equityCurve': 'Courbe de capital',
    'binance.stat.equityCurve.title': 'Courbe de capital sur toute la période (par trade, deux manches confondues)',
    'binance.stat.upbit': 'Upbit',
    'binance.stat.upbit.title': 'Positions/slots · gains/règlements',
    'binance.stat.upbitPnl': 'PnL Upbit',
    'binance.stat.realizedPnl': 'PnL réalisé',
    'binance.stat.realizedPnl.title': 'PnL réalisé par ligne (USDT)',
    'binance.lane.upbit': 'Short Upbit',
    'binance.lane.bithumb': 'Short Bithumb',
    'binance.lane.total': 'total',
    'binance.lane.liq': 'Cascade liq',
    'binance.lane.candLong': 'Long Bithumb',
    'binance.lane.pumpRide': 'Surfer',
    'binance.lane.gyeopLong': 'Long gyeop',
    'binance.lane.stairLong': 'Long stair',
    'binance.lane.dualShort': 'Double short',
    'binance.lane.inactive': 'inactif',
    'binance.lane.active': 'actif',
    'binance.stat.slip': 'Slippage (réel)',
    'binance.stat.slip.title': 'Slippage médian à l\'entrée par ligne (bp). Négatif = défavorable',
    'binance.stat.slip.roundtrip': 'aller-retour',
    'binance.stat.timing': 'Timing (sommet · entrée · détention)',
    'binance.stat.timing.title': 'Médiane hebdomadaire des minutes jusqu\'au sommet après l\'alerte (t_peak), et si le délai d\'entrée déployé y correspond. Bouge avant le P&L',
    'binance.stat.timing.implied': 'implicite',
    'binance.stat.timing.peak': 'sommet',
    'binance.stat.timing.deployed': 'entrée',
    'binance.stat.timing.hold': 'détention',
    'binance.stat.timing.match': '✓ après le sommet',
    'binance.stat.timing.mismatch': 'discordant',
    'binance.stat.timing.early': '⚠ avant le sommet',
    'binance.stat.timing.late': '⚠ trop tard',
    'binance.stat.lanes': 'Lignes · pos/k · gains',
    'binance.stat.lanes.title': 'Par ligne: positions/slots · gains/règlements',
    'binance.stat.lanesSize': 'Lignes · lev/notionnel',
    'binance.stat.lanesSize.title': 'Levier effectif et notionnel par ligne (USDT)',
    'binance.stat.lanes.col.lane': 'ligne',
    'binance.stat.lanes.col.status': 'état',
    'binance.stat.lanes.col.hold': 'pos/k',
    'binance.stat.lanes.col.legs': 'legs',
    'binance.stat.lanes.col.wins': 'gains',
    'binance.stat.lanes.col.pnl.hint': 'Cliquer pour le total',
    'binance.stat.lanes.col.lev': 'lev',
    'binance.stat.lanes.col.notional': 'notionnel',
    'binance.stat.lanes.col.timing': 'durée',
    'binance.stat.lanes.col.stop': 'stop',
    'binance.stat.lanes.col.strategy': 'stratégie',
    'binance.stat.lanes.col.strategy.hint': 'Sous-stratégies actives de la voie, dans le même ordre que durée et stop.',
    'binance.stat.lanes.col.stop.hint': 'Price stop %. Upbit short: evening/mountain. Mountain also exits at +15% with OI −2% (title).',
    'binance.stat.lanes.col.liveStats.hint': 'Current config_id settlements; else latest stamped config — live_ledger.',
    'binance.stat.lanes.col.liveStats.title': 'current · n={n} · avg {avg} · win {win} · {pnl} USDT · id {id}',
    'binance.stat.lanes.col.liveStats.empty': 'No settlements under this config yet',
    'binance.stat.liq.fired': '{n} décl. → {entered} entrées',
    'binance.regime.col.week': 'sem.',
    'binance.stat.upbitPnl.title': 'PnL réalisé manche Upbit (cumulé)',
    'binance.stat.upbitLev': 'Lev/notionnel Upbit',
    'binance.stat.upbitLev.title': 'Levier effectif / demandé · notionnel par trade (sizing risque Upbit)',
    'binance.stat.bithumb': 'Bithumb',
    'binance.stat.bithumb.title': 'Positions/slots · gains/règlements',
    'binance.stat.bithumb.off': 'Désactivé',
    'binance.stat.bithumbPnl': 'PnL Bithumb',
    'binance.stat.bithumbPnl.title': 'PnL réalisé manche Bithumb (cumulé)',
    'binance.stat.bithumbLev': 'Lev/notionnel Bithumb',
    'binance.stat.bithumbLev.title': 'Levier effectif · notionnel de base et plafond volume 1 min',
    'binance.tradeHistory.enteredOnly': 'Entrées (prévues)',
    'binance.tradeHistory.enteredOnly.title.hidden': "Seulement WATCH (surveillance liq incluse) + lignes entrées (OPEN/EXIT) · {n} lignes surveillance terminée/ignorées masquées",
    'binance.tradeHistory.enteredOnly.title.all': 'Afficher aussi les surveillances terminées et les lignes ignorées',
    'binance.tradeHistory.neededOnly': 'Utiles',
    'binance.tradeHistory.neededOnly.title.hidden': 'Upbit + nouveau plus haut Bithumb seulement · {n} alertes collecte/non résolues masquées',
    'binance.tradeHistory.neededOnly.title.all': 'Afficher aussi les alertes collecte seule',
    'binance.tradeHistory.title': 'Historique',
    'binance.table.header.symbol': 'Symbole',
    'binance.table.header.status': 'Statut',
    'binance.table.header.alert': 'Alerte',
    'binance.table.header.sizing': 'Taille',
    'binance.table.header.chart': 'Graphiques',
    'binance.table.header.pnl': 'PnL',
    'binance.manualClose.button': 'Clôturer',
    'binance.manualClose.confirm': 'Confirmer ?',
    'binance.manualClose.working': 'Envoi…',
    'binance.manualClose.queued': 'En file · vente sous {eta}s',
    'binance.manualClose.cancelled': 'Annulé',
    'binance.manualClose.failed': 'Échec : {error}',
    'binance.manualClose.title': "Clôturer {perp} maintenant. Après la passkey (Face ID/Touch ID), le bot vend au cycle suivant.",
    'binance.manualEntry.button': 'Entrer',
    'binance.manualEntry.confirm': 'Confirmer ?',
    'binance.manualEntry.working': 'Envoi…',
    'binance.manualEntry.queued': 'En file · entrée sous {eta}s',
    'binance.manualEntry.entered': 'Réussi',
    'binance.manualEntry.failed': 'Échec : {error}',
    'binance.manualEntry.timeout': 'Résultat lent — voir le tableau',
    'binance.manualEntry.reason.lane_busy': 'Manche {holder} déjà en position',
    'binance.manualEntry.reason.lane_busy.unknown': 'Autre manche déjà en position',
    'binance.manualEntry.holder.liq': 'liq',
    'binance.manualEntry.holder.upbit': 'up-short',
    'binance.manualEntry.holder.bh': 'bithumb',
    'binance.manualEntry.holder.cl': 'bit-long',
    'binance.manualEntry.holder.long': 'long',
    'binance.manualEntry.holder.orphan': 'orphelin exchange',
    'binance.manualEntry.reason.margin': 'Marge insuffisante',
    'binance.manualEntry.reason.liq_reserve': 'Réserve marge manche liq',
    'binance.manualEntry.reason.liq_priority': 'Priorité liq · upbit cède',
    'binance.manualEntry.reason.already_open': 'Déjà en position upbit',
    'binance.manualEntry.reason.slot_full': 'Slots pleins',
    'binance.manualEntry.reason.late': 'Fenêtre expirée',
    'binance.manualEntry.reason.halted': 'Trader arrêté',
    'binance.manualEntry.reason.min_notional': 'Notionnel mini',
    'binance.manualEntry.reason.capacity': 'Capacité dépassée',
    'binance.manualEntry.reason.entry_fail': 'Ordre échoué',
    'binance.manualEntry.reason.no_pullback': 'Pas de pullback',
    'binance.manualEntry.reason.runup_low': 'Runup insuffisant',
    'binance.manualEntry.reason.rv_low': 'Volatilité insuffisante',
    'binance.manualEntry.reason.no_drop': 'Repli insuffisant',
    'binance.manualEntry.reason.kr_segment_high': 'Seuil haut segment KR',
    'binance.manualEntry.reason.hot_ban': 'Interdit de re-short après abort/no_pullback',
    'binance.manualEntry.reason.scout_run_hi': '1er du jour · watch trop haut (scout)',
    'binance.manualEntry.title': "Entrer {perp} maintenant. Après la passkey, le bot entre sans attendre le pullback.",
    'binance.table.header.detail': 'Détail',
    'binance.table.header.exchange.title': 'Bourse',
    'binance.table.header.lane.title': 'Lane',
    'binance.table.empty': 'Aucun événement',
    'binance.exchange.short.upbit': 'Up',
    'binance.exchange.short.bithumb': 'Bi',
    'binance.exchange.short.coinone': 'Co',
    'binance.exchange.full.upbit': 'Upbit',
    'binance.exchange.full.bithumb': 'Bithumb',
    'binance.exchange.full.coinone': 'Coinone',
    'binance.exchange.full.unknown': 'Inconnu',
    'binance.status.alert': 'ALERTE',
    'binance.status.trigger': 'DECLENCHE',
    'binance.status.pending': 'EN ATTENTE',
    'binance.status.exit': 'SORTIE',
    'binance.status.open': 'OUVERT',
    'binance.status.skip': 'IGNORÉ',
    'binance.status.short': 'SHORT',
    'binance.status.reshort': 'RESHORT',
    'binance.status.long': 'LONG',
    'binance.status.fail': 'ÉCHEC',
    'binance.status.collect': 'COLLECTE',
    'binance.status.watch': 'SURVEILLE',
    'binance.status.watchEnd': 'FIN SURVEILLANCE',
    'binance.pnl.fee': 'Frais {amount}',
    'binance.pnl.funding': 'Funding {amount}',
    'binance.skipPnl.stopped': 'Stop',
    'binance.skipPnl.held': 'Tenu {min} min',
    'binance.skipPnl.pullbackHeld': 'Surveillance {watch} · hold {hold} min',
    'binance.skipPnl.noPullback': 'Pas de pullback',
    'binance.skipPnl.watchOnly': 'Surveillance {watch} min',
    'binance.skipPnl.coarse': 'Estimé (1 min)',
    'binance.skipPnl.title': "P&L hypothétique d'une entrée non prise ({lane} · {reason} · {bucket}). Ce n'est pas une exécution réelle. Le graphique est le prix depuis l'alerte.",
    'binance.skipReport.title': 'P&L contrefactuel par filtre',
    'binance.skipReport.window': '{days} jours (tout)',
    'binance.skipReport.capacity': 'capacité',
    'binance.regime.title': 'Régime',
    'binance.regime.hint': 'live_ledger trades — weekly ISO week (KST) · lane avg net% · win%(n). Not counterfactual regime_weekly.',
    'binance.liqVitality.dead': 'DEAD',
    'binance.liqVitality.marginal': 'MARGINAL',
    'binance.liqVitality.alive': 'ALIVE',
    'binance.liqVitality.unknown': '–',
    'binance.liqVitality.live.off': 'OFF',
    'binance.liqVitality.live.hold': 'HOLD',
    'binance.liqVitality.live.discuss': 'discuss',
    'binance.liqVitality.live.keep': 'keep',
    'binance.liqVitality.live.turn_off': 'turn off',
    'binance.liqVitality.roll': 'N{n}',
    'binance.liqVitality.hint': 'liq_trigger rolling score. dead if avg<0 or ratio<1.05; alive if avg>0, ratio≥1.5, n≥20. No auto yaml.',
    'binance.abortReport.title': 'Contrefactuel abort — sans la coupe',
    'binance.stopReport.title': 'Contrefactuel stop — sans le stop',
    'binance.stopReport.empty': "0 stop. Chaque stop-out sera comparé à « tenir 30 min sans stop » (pas de rétroactif).",
    'binance.stopReport.compare': 'stop {actual} en moyenne vs {base} en tenant 30 min',
    'binance.longReport.title': 'Contrefactuel long — sans la règle de sortie',
    'binance.longReport.empty': "0 passage en long. Quand un abort coupe un short et ouvre un long, il sera comparé à « tenir 30 min sans la sortie sur plateau » (stop dur -2% conservé).",
    'binance.longReport.compare': 'long réalisé {actual} en moyenne vs {base} sans la règle de sortie',
    'binance.longSkipReport.title': 'Contrefactuel long non ouvert — si ouvert',
    'binance.longSkipReport.empty': "0 cas où l'abort a coupé le short sans ouvrir de long.",
    'binance.longSkipReport.compare': '{n} non ouverts. Si ouverts : {base} en moyenne (total {sum}p) — négatif si ne pas ouvrir a coûté.',
    'binance.abortReport.empty': "0 abort. Deux jambes en OU — repli de prix rapide, ou hausse d'OI avec flux acheteur soutenu. Seuils exacts dans la ligne abort ci-dessus.",
    'binance.abortReport.saved': "L'abort a gagné sur {saved} des {n} cas.",
    'binance.abortReport.sum': 'total {sum}p',
    'binance.abortReport.compare': 'abort {actual} en moyenne vs {base} sans la coupe',
    'binance.abortReport.stopRate': 'Aurait touché le stop 6% dans {rate} des cas',
    'binance.abortReport.pending': '{n} en attente (hold virtuel de 30 min)',
    'binance.abortReport.note': ">0 : l'abort a évité une perte ; <0 : il a coupé un gain. Source : markPrice@1s collecté.",
    'binance.abortReport.legTitle': 'Par jambe',
    'binance.abortReport.legCol.leg': 'Jambe',
    'binance.abortReport.legCellTitle': '{label} — {hint}',
    'binance.flipReport.title': 'Contrefactuel flip — sans le flip',
    'binance.flipReport.col.type': 'Type',
    'binance.flipReport.col.count': 'Décl.',
    'binance.flipReport.col.betterRate': 'Flip gagne',
    'binance.flipReport.col.avgDelta': 'Δ moyen',
    'binance.flipReport.col.sumDelta': 'Contribution',
    'binance.flipReport.col.avgBase': 'Sans flip',
    'binance.flipReport.col.avgTotal': 'Réel',
    'binance.flipReport.emptyOn': "0 déclenchement. Flips actifs : {on} — ⚠️ mais les déclenchements ne sont pas enregistrés (record_flip non câblé) : « inconnu », pas « rien »." ,
    'binance.flipReport.emptyOff': '0 déclenchement — aucun flip actif.',
    'binance.flipReport.pending': '{n} en attente de scoring (jambe longue en cours)',
    'binance.flipReport.note': "Contribution = réel (jambe courte + longue) − sans flip (courte seule). >0 : le flip a rapporté ; <0 : il fallait garder le short.",
    'binance.skipReport.lane.deployed': 'ligne déployée',
    'binance.skipReport.lane.research': 'recherche',
    'binance.skipReport.col.filter': 'Filtre',
    'binance.skipReport.col.count': 'Nb',
    'binance.skipReport.col.avg': 'Moyenne',
    'binance.skipReport.col.sum': 'Total',
    'binance.skipReport.col.winRate': 'Réussite',
    'binance.skipReport.col.stopRate': 'Stops',
    'binance.skipReport.verdict.costly': 'Les {n} rejets totalisent {sum}% — le filtre a laissé filer autant.',
    'binance.skipReport.verdict.worth': 'Les {n} rejets totalisent {sum}% — le filtre a évité autant.',
    'binance.skipReport.note': "Entrée alerte+1 min / sortie +30 min / stop 6%, scoré avec les règles du live. Les lignes « capacité » (slot plein, etc.) ne jugent pas le filtre et sont exclues du total.",
    'binance.sizing.risk': '{pct}%',
    'binance.pnlModal.title': 'PnL réalisé',
    'binance.pnlModal.note': 'Heure KST. PnL des exécutions réelles, pas du backtest.',
    'binance.pnlModal.empty': 'Aucun trade clôturé.',
    'binance.pnlModal.col.period': 'Période',
    'binance.pnlModal.col.count': 'Nombre',
    'binance.pnlModal.col.winRate': 'Taux de gain',
    'binance.pnlModal.col.stops': 'Stops',
    'binance.pnlModal.col.perTrade': 'Par trade',
    'binance.pnlModal.section.thisWeekDaily': 'Cette semaine par jour ({start} ~)',
    'binance.pnlModal.section.weekly': 'Par semaine',
    'binance.pnlModal.inProgress': 'En cours',
    'binance.pnlModal.total': 'Total',
    'binance.filterModal.title': 'Filtres actuellement appliqués',
    'binance.filterModal.note': 'Valeurs lues de la config déployée — le bot en cours, pas la doc.',
    'binance.filterModal.lane.common': 'Commun — les deux manches',
    'binance.filterModal.lane.upbit': 'Short Upbit',
    'binance.filterModal.lane.bh': 'Short Bithumb',
    'binance.filterModal.lane.liq': 'Cascade liq',
    'binance.filterModal.count': '{n}',
    'binance.filter.effect.skip': 'Ignorer l\'alerte',
    'binance.filter.effect.entry': 'Timing d\'entrée',
    'binance.filter.effect.size': 'Ajuster la taille',
    'binance.filter.effect.collect': 'Collecte seule',
    'binance.filter.effect.sleeve': 'Manche séparée',
    'binance.filter.effect.exit': 'Règle de sortie',
    'binance.filter.effect.pending': 'En attente — à revalider',
    'binance.filter.effect.label_only': 'Simulation — sans ordre',
    'binance.skipReport.newlistingSim': 'Simu. exemption nouvelle cotation',
    'binance.newlistingReport.title': 'Contrefactuel exemption — si exemptée',
    'binance.newlistingReport.empty': '0 étiquette. Se remplit quand un actif coté depuis <{days}j échoue au seuil runup (pas de rétroactif).',
    'binance.newlistingReport.sum': '{n} cas · total {sum}p · {avg} par cas',
    'binance.newlistingReport.rate': 'réussite {win} · stop {stop}',
    'binance.newlistingReport.pending': '{n} en attente de score',
    'binance.newlistingReport.gate': 'Seuil n≥{need} — étiquette seule, aucun ordre.',
    'binance.segmentHighReport.title': 'Contrefactuel segment_high (skip ≥40%) — si ouvert',
    'binance.segmentHighReport.empty': '0 skip segment_high scoré.',
    'binance.segmentHighReport.sum': '{n} cas · total {sum}p · {avg} par cas',
    'binance.segmentHighReport.rate': 'réussite {win} · stop {stop}',
    'binance.segmentHighReport.abort': 'abort reconstruit {scored} cas, déclenché {fired}',
    'binance.segmentHighReport.abortHint': "Reconstruction possible seulement sur le tier froid (ticks présents, dès 2026-08-02) et pour les stops. 0/N = abort n'a bloqué aucun de ces stops — une hausse segment_pct est une montée lente, angle mort structurel du détecteur abort (annexe A).",
    'binance.segmentHighReport.runupTitle': 'Bandes runup_60m_pct (axe hausse rapide/lente)',
    'binance.segmentHighReport.segmentTitle': 'Bandes segment_pct (40-50 / ≥50)',
    'binance.segmentHighReport.col.band': 'Bande',
    'binance.segmentHighReport.gate.judged': 'Seuil n≥{need} atteint — vérifier séparément la dépendance à un seul symbole (queue épaisse).',
    'binance.segmentHighReport.gate.notJudged': 'Non tranché — n={n}, seuil n≥{need}. Collecte en cours (doc stream-upbit-segment-high-runup-short-2026-08-06 §conclusion).',
    'ibkr.swing.subtitle.line1': 'Long journalier MES·MNQ·MGC·ZN · paper',
    'ibkr.swing.subtitle.line2': 'Rééquilibrage dim–jeu 18:15 ET',
    'ibkr.swing.subtitle.line3': 'Globex dim 18:00–ven 17:00 ET · pause 17–18 ET',
    'ibkr.swing.legs.empty': 'Aucune jambe',
    'ibkr.swing.section.legs': 'Jambes',
    'ibkr.swing.trades.empty': 'Aucun trade',
    'ibkr.tfsa.subtitle.line1': 'Filtre analystes TipRanks (2/3)',
    'ibkr.tfsa.subtitle.line2': 'rank ≤ 50 upgrade · stock SR ≥ 70 %',
    'ibkr.tfsa.subtitle.line3': 'upside ≥ 15 % · pas d\'ordres (paper)',
    'ibkr.tfsa.table.empty': 'Aucun journal',
    'ibkr.tfsa.section.analystFilter': 'Filtre analystes',
    'ibkr.tfsa.table.ticker': 'Ticker',
    'ibkr.tfsa.table.signal': 'Signal',
    'ibkr.tfsa.table.analyst': 'Analyste',
    'ibkr.tfsa.table.sr': 'SR',
    'ibkr.tfsa.table.upside': 'Upside',
    'ibkr.tfsa.table.conv': 'Conv',
    'kiwoom.pairs.subtitle.line1': 'Paires z-score banques/télécom KRX',
    'kiwoom.pairs.subtitle.line2': 'EOD 16:05 KST · paper only',
    'kiwoom.pairs.subtitle.line3': 'Pas d\'ordres · exécutions simulées seulement',
    'kiwoom.pairs.noSnapshot': 'Pas d\'instantané pairs-paper (généré après la clôture)',
    'kiwoom.pairs.section.pairs': 'Paires',
    'kiwoom.pairs.section.fillsToday': 'Exécutions du jour',
    'kiwoom.pairs.label.bankKbShinhan': 'Banques (KB-Shinhan)',
    'kiwoom.pairs.label.bankKbHana': 'Banques (KB-Hana)',
    'kiwoom.pairs.label.bankShinhanHana': 'Banques (Shinhan-Hana)',
    'kiwoom.pairs.label.telecomSktKt': 'Télécom (SKT-KT)',
    'kiwoom.pairs.table.pairs.empty': 'Aucune paire',
    'kiwoom.pairs.table.fills.empty': 'Aucune exécution',
    'kiwoom.pairs.table.pair': 'Paire',
    'kiwoom.pairs.table.side': 'Côté',
    'kiwoom.pairs.table.z': 'Z',
    'kiwoom.pairs.table.hold': 'Dét.',
    'kiwoom.pairs.table.symbol': 'Symbole',
    'kiwoom.pairs.table.qty': 'Qté',
    'kiwoom.currency.krw': '{n} KRW',
    'kiwoom.daytrading.subtitle.line1': 'KRX thème-suiveur-dip limite · paper',
    'kiwoom.daytrading.subtitle.line2': 'Exécutions en séance · paper only',
    'kiwoom.daytrading.subtitle.line3': 'Pas d\'ordres · exécutions EOD simulées',
    'kiwoom.daytrading.placeholder': '⭐️ Section réservée — Kiwoom day-trading, Bithumb ou Coinone, on verra ⭐',
    'kiwoom.daytrading.legend.live': 'Paper réel',
    'kiwoom.daytrading.legend.backtest': 'Backtest',
    'kiwoom.daytrading.awaiting': '1re séance en attente — reprise après Chuseok',
    'kiwoom.daytrading.section.live': 'Journalier (live)',
    'kiwoom.daytrading.section.backtest': 'Journalier backtest (in-sample · contexte)',
    'kiwoom.daytrading.section.trades': 'Exécutions',
    'kiwoom.daytrading.section.trades.count': '',
    'kiwoom.daytrading.tab.live': 'Live',
    'kiwoom.daytrading.tab.backtest': 'Backtest',
    'kiwoom.daytrading.table.date': 'Date',
    'kiwoom.daytrading.table.signals': 'Signaux',
    'kiwoom.daytrading.table.taken': 'Entrées',
    'kiwoom.daytrading.table.win': 'Gain%',
    'kiwoom.daytrading.table.equity': 'Equity',
    'kiwoom.daytrading.table.symbol': 'Symbole',
    'kiwoom.daytrading.table.side': 'Sens',
    'kiwoom.daytrading.table.qty': 'Qté',
    'kiwoom.daytrading.table.trades.empty': 'Aucune exécution',
    'kiwoom.daytrading.stat.equity.title': 'Solde paper live (départ 1M)',
    'kiwoom.daytrading.stat.start': 'Départ',
    'kiwoom.daytrading.stat.today': 'Jour',
    'kiwoom.daytrading.stat.dd.title': 'Tirage vs pic% · MDD = max période',
    'kiwoom.daytrading.disclaimer': 'Backtest in-sample optimiste — validation en paper réel (départ 1M)',
    'bithumb.spot.title': 'Spot Paper',
    'bithumb.spot.score': 'Bilan',
    'bithumb.spot.score.aria': 'Bilan',
    'bithumb.spot.detail': 'Détail',
    'bithumb.spot.liveStack': 'Pile live',
    'bithumb.spot.liveStack.detail': 'Détail pile live',
    'bithumb.spot.liveStack.detailNote': 'Spot paper : livre écran = ordres — mark_out@22–01 (oracle Oct). Les cases du tableau sont ces règles.',
    'bithumb.spot.subtitle': 'mark_out@22–01 · sans Core∪sat · entrée tick · paper · WR cible {target}%',
    'bithumb.spot.detail.hasMark': 'A un mark USDT-M',
    'bithumb.spot.subtitle.clusterWait': ' · cluster en attente',
    'bithumb.spot.subtitle.updated': ' · màj {t}',
    'bithumb.spot.table.empty': 'Aucune alerte',
    'bithumb.spot.stat.wrTarget': 'cible {target}%',
    'bithumb.spot.stat.sum': 'Somme (prix%)',
    'bithumb.spot.stat.stackN': 'pile n={n}',
    'bithumb.spot.status.ready': 'PRÊT',
    'bithumb.spot.status.wait': 'ATTENTE',
    'bithumb.spot.status.expired': 'EXPIRÉ',
    'bithumb.spot.detail.sessionEnd': 'Session terminée (après 02:00)',
    'bithumb.spot.detail.waitWindow': 'Fenêtre d\'entrée en attente',
    'bithumb.spot.detail.notAllowlisted': 'Hors allowlist',
    'bithumb.spot.detail.q1hBlocked': 'sat q1h≥50',
    'bithumb.spot.detail.overshoot': 'Dépassement board',
    'bithumb.spot.detail.segRise': 'Hausse segment {pct}%',
    'bithumb.spot.lane': 'Voie',
    'bithumb.spot.rule.entry': 'Entrée',
    'bithumb.spot.rule.exit': 'Sortie',
    'bithumb.spot.rule.order': 'Ordre',
    'bithumb.spot.allowlist.failed': 'Allowlist quotidien échoué{detail}',
    'bithumb.spot.allowlist.stale': 'Allowlist quotidien en retard — pas de succès depuis 30 h{detail}',
    'bithumb.spot.allowlist.missing': 'Statut allowlist manquant{detail}',
    'charts.back': '← Tableau',
    'charts.title.live': 'Symboles alertés · bougies 1 min · 24 h',
    'charts.title.mountain': '{sym} mont · cluster ±24 h',
    'charts.title.mountain36': '{sym} mont · cluster ±36 h',
    'charts.title.mountainLate': '{sym} mont · +10 % du creux ~ −20 % du pic',
    'charts.count': '{n} symboles',
    'charts.noBars': '(+{n} sans données)',
    'charts.truncated': ' · 40 derniers seulement',
    'charts.auto': 'Màj auto 30 s',
    'charts.lane.ready': 'Couleur de la voie {lane}',
    'charts.lane.soon': 'Pas encore de données (bouton seul)',
    'charts.baseline': 'Base',
    'charts.baseline.window': 'Début fenêtre',
    'charts.baseline.alert': '1re alerte',
    'charts.baseline.fire': '1er déclenchement',
    'charts.baseline.peak': 'Pic',
    'charts.hideAll': 'Tout masquer',
    'charts.hideAll.title': 'Masquer toutes les lignes',
    'charts.showAll': 'Tout afficher',
    'charts.showAll.hidden': ' (masqués {n})',
    'charts.showAll.title': 'Réafficher les lignes masquées',
    'charts.live': '← Temps réel',
    'charts.live.title': 'Fermer la fenêtre passée et revenir à aujourd\'hui',
    'charts.ladder': 'Échelle',
    'charts.visionStrict': 'Vision ≥300 %',
    'charts.hint.visionStrict': 'jan–juil · open→max · listing inclus',
    'charts.stop': 'Stop',
    'charts.hint.liq': 'cascade · liquidations cumulées ≥100',
    'charts.hint.bh': 'live stack 6 % · +5 % / 10 min au tick et au fill',
    'charts.loss': 'Tardif',
    'charts.hint.upbit': 'OI +30 % · 5–15 % sous le pic · sep–oct',
    'charts.hint.gyeop': 'hausse ≥8 % sur 15 s · août·oct',
    'charts.gyeopFast': '≥8 %',
    'charts.hint.stair': 'classe LSK·IRYS · liq short / rng60 · trail8',
    'charts.stairFast': 'flip long',
    'charts.marker.exit': 'sortie',
    'charts.wait.entry': 'entrée {n} min',
    'charts.wait.exit': 'sortie {n} min',
    'charts.none': 'Aucun',
    'charts.level.step': 'palier {n}',
    'charts.axis.lead': 'Axe vertical (log) = ',
    'charts.axis.base.window': 'début (liq = open→high)',
    'charts.axis.base.peak': 'plus haut de la fenêtre',
    'charts.axis.base.fire': 'prix du 1er déclenchement',
    'charts.axis.base.alert': 'prix de la 1re alerte',
    'charts.axis.body': ' en % (les prix sont ramenés en % pour partager un axe).',
    'charts.axis.peakNote': ' En base pic, la valeur actuelle = repli depuis le pic (même base que le tableau).',
    'charts.axis.price': 'Prix = mark Binance perp · flèche = heure de {what} pour ce symbole.',
    'charts.what.liq': 'déclenchement cascade',
    'charts.what.bh': 'alerte Bithumb · entrée · stop',
    'charts.what.upbit': 'alerte Upbit',
    'charts.what.upbitLoss': 'entrée tardive · 210 min',
    'charts.what.gyeop': 'entrée·sortie gyeop',
    'charts.what.stair': 'entrée·sortie stair',
    'charts.window': ' · fenêtre ',
    'charts.mountainSpan': ' (mont ±24 h)',
    'charts.span.gyeop': ' (entrée ±2 min · tick)',
    'charts.span.liqFlip': ' (LSK·IRYS · tick·sec · entrée·sortie)',
    'charts.span.stair': ' (entrée ±30 min · tick·sec)',
    'charts.mountainSpan36': ' (mont ±36 h)',
    'charts.mountainSpanLate': ' (mont de cette entrée)',
    'charts.updated': ' · màj {t}',
    'charts.server': ' · serveur {n} ms',
    'charts.laneSoonNote': ' · cette voie n\'a encore que le bouton',
    'charts.loading.mountain': 'Chargement… le serveur construit la fenêtre mont ±24 h (affichage auto dès que c\'est prêt · {n} s)',
    'charts.loading.mountain36': 'Chargement… le serveur construit la fenêtre mont ±36 h (affichage auto dès que c\'est prêt · {n} s)',
    'charts.loading.mountainLate': 'Chargement… le serveur construit le mont de cette entrée (affichage auto dès que c\'est prêt · {n} s)',
    'charts.loading.mountainShort': 'Chargement… (mont ±24 h — construit en arrière-plan)',
    'charts.loading.mountainShort36': 'Chargement… (mont ±36 h — construit en arrière-plan)',
    'charts.loading.mountainShortLate': 'Chargement… (mont de cette entrée — construit en arrière-plan)',
    'charts.loading.gyeop': 'Chargement… (tick · {n} s)',
    'charts.loading.gyeopShort': 'Chargement… (tick)',
    'charts.loading.first': 'Chargement… (le premier chargement étale 24 h, quelques secondes)',
    'charts.empty.historic': 'Aucun symbole {what} avec des bougies dans cette fenêtre.',
    'charts.empty.today': 'Aucun symbole {what} avec des bougies aujourd\'hui (KST).',
    'charts.empty.what.liq': 'déclenché (cascade)',
    'charts.empty.what.bh': 'stop',
    'charts.empty.what.upbit': 'alerté Upbit',
    'charts.empty.what.gyeop': 'gyeop',
    'charts.empty.what.stair': 'stair',
    'charts.empty.what.alert': 'alerté',
    'charts.stale': 'arrêté {h}h{m}m',
    'charts.legend.title': '{perp} · bougies {bars} · {kind} {n}\nprix {px}{warming}{note}\nclic = masquer/afficher',
    'charts.legend.kind.liq': 'décl.',
    'charts.legend.kind.alert': 'alertes',
    'charts.legend.warming': '\n(le serveur complète les 24 h)',
    'charts.noBarsLine': 'Sans bougies : ',
    'charts.err.server': 'Le serveur a signalé un échec',
    'charts.err.ladder': 'Échec de la liste d\'échelles',
    'charts.marker.entry': 'entrée',
    'charts.marker.stop': 'stop',
    'charts.cum': 'cumul',
    'charts.mountainWord': 'mont',
    'charts.spanTitle': 'fenêtre = mont ±24 h',
    'charts.spanTitle36': 'fenêtre = mont ±36 h',
  },
} as const;

export type DashboardLocale = keyof typeof dashboardMessages;
export type DashboardMessageKey = keyof typeof dashboardMessages.en;

/** Root dashboard path for a locale (`/en`, `/kr`, `/fr`). */
export function dashboardHomePath(locale: DashboardLocale): string {
  if (locale === 'kr') return '/kr';
  if (locale === 'fr') return '/fr';
  return '/en';
}

/** Charts page path for a locale. */
export function binanceChartsPath(locale: DashboardLocale): string {
  if (locale === 'kr') return '/binance-charts/kr';
  if (locale === 'fr') return '/binance-charts/fr';
  return '/binance-charts/en';
}

export function formatDashboardMessage(
  locale: DashboardLocale,
  key: DashboardMessageKey,
  params?: Record<string, string | number>,
): string {
  let text: string = dashboardMessages[locale][key] ?? dashboardMessages.en[key] ?? key;
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    });
  }
  return text;
}
